// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Aktion fehlgeschlagen',
  success: 'Aktion war erfolgreich',
  title: {
    preview: 'Vorschau',
    cropImage: 'Bild zuschneiden',
    attention: 'Achtung',
    changeBookCoverTemplate: 'PDF Cover Vorlage ändern',
    shareThisArticle: 'Diesen Artikel teilen',
    insertImage: 'Bild hinzufügen',
    insertEmbed: 'Video einfügen',
    insertLink: 'Link hinzufügen',
    book: 'PDF',
    addAutoresponders: 'Autoresponder hinzufügen',
    editAutoresponder: 'Autoresponder ändern',
    passwordError: 'Passwort Fehler',
    general: 'Generell',
    salesPage: 'Sales page',
    design: 'Design',
    seo: 'SEO',
    access: 'Zugang',
    passwordDidntWork: 'Leider funktioniert das Passwort nicht',
    accessSentToEmail: 'Der Zugang zum PDF wurde dir per Mail gesendet.',
    openBook: 'Offenes PDF',
    myBook: 'Meine PDF',
    myProfile: 'Mein Profil',
    logout: 'Log out',
    profile: 'Profil',
    security: 'Security',
    changePassword: 'Passwort ändern',
  },
  socialMedia: {
    embeddable: 'Embeddable',
    notifySubscribers: 'Notify subscribers',
    madeForKids: 'Made for kids',
    fbReelRatioError: 'Ihr Video hat nicht das richtige Seitenverhältnis von 9x16 (vertikal) für Facebook',
    fbReelResolutionError: 'Die Mindestauflösung beträgt 540 x 960 Pixel. Die empfohlene Auflösung beträgt 1080 x 1920 Pixel.',
    fbReelLengthError: 'Die Dauer der Rollen muss zwischen 3 und 90 Sekunden liegen.',
    threadsConnectDescription: 'FunKISocial versucht automatisch, sich mit dem Konto zu verbinden, in das Sie in Ihrem Browser eingeloggt sind. Wir empfehlen daher, sich zuerst mit dem Konto, das Sie mit FunKISocial verbinden möchten, bei threads.net anzumelden und dann zu FunKISocial zu gehen, um den Kanal zu verbinden.',
    letsKeepGoing: 'Weiter geht\'s',
    couldntConnectYoutube: 'Whoops, we couldn\'t find any YouTube channel in your account',
    makeSureYouAreSigningInYoutube: 'Make sure you\'re signing in with a YouTube account with existing YouTube channels',
    authPageFullAccess: 'Also on the authorization page, make sure that you have given full access.',
    couldntConnectThreads: 'Whoops, we couldn\'t connect Threads profile',
    tryAgainLaterThreads: 'Versuchen Sie es später noch einmal. Vergewissern Sie sich auf der Autorisierungsseite, dass Sie vollen Zugriff auf die FunKISocial App gewährt haben. Wenn dies nicht gelingt, versuchen Sie, den Zugriff für die FunKITools App in den Datenschutzeinstellungen des Threads zu widerrufen und versuchen Sie den Verbindungsprozess erneut.',
    learnMoreHowToRevoke: '<a href="https://www.facebook.com/help/instagram/342170118538764" target="__blank" class="text-primary">Lesen Sie mehr darüber, wie Sie den Zugriff für externe Apps widerrufen können.</a>',
    disableDuet: 'Duett',
    disableStitch: 'Stitch',
    revoke: {
      statusOfData: 'Status der gelöschten Nutzerdaten',
      insertCode: 'Code einfügen',
      checkStatus: 'Status kontrollieren',
      dataDeleted: 'Daten gelöscht',
      noUser: 'Nutzer existiert nicht',
      noUserDesc: 'Leider haben wir diesen Nutzer nicht gefunden.',
    },
    instagramSupportOneMedia: 'Die Instagram-API unterstützt nur eine Mediendatei für eine Story.',
    socialMediaPlaner: 'Social Media Planer',
    mediaPlaner: 'Dein persönlicher Planer',
    mediaPlanerDescription: 'Entfessele deinen Erfolg in den sozialen Medien mit einem Social-Media-Planer! Er ist dein ultimatives Werkzeug für mühelose Terminplanung und Organisation von Inhalten auf Plattformen wie Facebook, Instagram und Twitter. Sag Tschüss zum Chaos und hallo zu einer strategischen, konsistenten Online-Präsenz. Steigere deine Marke, begeistere deine Zielgruppe und erfülle deine Marketingziele ganz einfach!',
    manageYourChannels: 'Manage deine Kanäle',
    disconnect: 'Entfernen',
    disconnected: 'getrennt',
    notConnected: 'nicht verbunden',
    refreshConnection: 'Verbindung erneuern',
    disconnectChannel: 'Kanal entfernen',
    deleteChannel: 'Kanal löschen',
    facebookTip: 'Das Verbinden von Facebook Seiten und Gruppen ist ein Kinderspiel! Durch die Integration dieser sozialen Medien kannst Du mühelos Deine Zielgruppe verwalten und ansprechen. Klicke einfach auf das entsprechende Symbol des jeweiligen Netzwerks, folge dem Autorisierungsprozess und voilà! Du hast nahtlosen Zugriff auf Deine Seiten und Gruppen und kannst Deine Social-Media-Aktivitäten effizient steuern',
    instagramTip: 'Die Integration von Twitter in Deine Software ist schnell und unkompliziert! Durch diese Verbindung kannst Du Deine Präsenz auf Twitter problemlos verwalten. Klicke einfach auf das Twitter-Symbol, durchlaufe die Autorisierungsschritte und schon kannst Du auf Deine Tweets, Follower und mehr zugreifen.',
    twitterTip: 'Das Verbinden von Instagram mit Deiner Software ist ein Kinderspiel! Durch diese Integration kannst Du Deine Instagram-Präsenz mühelos verwalten. Klicke auf das Instagram-Symbol, vervollständige den Autorisierungsprozess und erhalte Zugriff auf Deine Fotos, Follower und Engagement-Metriken. Es war noch nie einfacher, Dein Instagram-Spiel aufrechtzuerhalten!',
    noChannels: 'Du hast noch keine Kanäle verbunden',
    connectFirstChannel: 'Verbinde deinen ersten Social Media Kanal',
    connect: 'Verbinden',
    connected: 'In Verbindung gebracht',
    connectSuccessful: 'Die Verbindung hat geklappt',
    wellDone: 'Gratuliere!<br> Du hast deinen Kanal verbunden',
    successfullyConnected: 'Sie haben einen Kanal erfolgreich verbunden. Jetzt können Sie mit der Planung von Beiträgen beginnen.',
    goToPlanner: 'Zum Planer',
    somethingWrong: 'Ups, etwas ist schiefgelaufen',
    tryAgain: 'Bitte versuche es erneut. Bitte stell sicher, dass du unsere Anleitung verfolgst',
    establishingConnection: 'Verbindung wird hergestellt',
    disconnectChannelTitle: 'Du bist ein Schritt davon entfernt deinen Kanal zu entfernen',
    notAbleToPost: 'Du verlierst die Möglichkeit, diesem Kanal zu posten. Alle bestehenden Analytics, Kampagnen und geplante Beiträge und Daten werden gelöscht und gehen endgültig verloren. <b>Dieser Schritt kann nicht rückgängig gemacht werden.</b>',
    haveIssues: 'Probleme mit der Verbindung? Versuche die Aktualisieren-Funktion.',
    facebookType: 'Facebook Konto wählen',
    linkedinType: 'LinkedIn Konto wählen',
    checkGuide: 'Du findest mehr Infos in unserer Anleitung zu den Konten hier',
    linkedinPage: 'LinkedIn Seite',
    linkedinProfile: 'LinkedIn Profil',
    linkedinPageDescription: 'Eine öffentliche Seite',
    linkedinProfileDescription: 'Eine öffentliche Profil',
    facebookPage: 'Facebook Seite',
    facebookPageDescription: 'Eine öffentliche Seite, die andere Nutzer liken können',
    facebookGroup: 'Facebook Gruppe',
    facebookGroupDescription: 'Eine Gruppe, in der Nutzer beitreten können.',
    facebookGroupDescriptionNotAvailable: 'Die direkte Veröffentlichung in Facebook-Gruppen wird von Meta nicht mehr unterstützt.',
    startConnecting: 'Verbindung erstellen',
    likeToAdd: 'Welchen Kanal möchtest du hinzufügen?',
    addLimit: 'Du kannst bis zu 2 Kanäle hinzufügen',
    seeingUnenviableChannels: 'Es fehlen Kanäle?',
    learnWhy: 'Lerne warum',
    Today: 'Heute',
    DayIsOver: 'Dieser Tag ist schon vorüber',
    createPost: 'Beitrag erstellen',
    CreateNewPost: 'Neuen Beitrag erstellen',
    attachOnlyOne: 'Wir können nur eine Art Datei gleichzeitig hochladen. Entweder Fotos, ein Gif oder ein Video.',
    uploadLimit: 'Wir können maximal 10 Dateien hochladen.',
    generateImageWithAI: 'Bild mit KI generieren',
    pictureDescription: 'Beschreibung des Bilds',
    picturePlaceholder: 'Du kannst hier einen Text für die KI erstellen um das gewünschte Bild zu beschreiben.',
    media: 'Media',
    addMedia: 'Media hinzufügen',
    generateWithAI: 'Mit KI generieren',
    or: 'oder',
    text: 'Text',
    writeText: 'Schreibe einen Text',
    facebookLimit: 'Facebook unterstützt bis zu 10 Bilder oder 1 Video (entweder Bilder oder ein Video)',
    TwitterLimit: 'Twitter unterstützt bis zu 4 Bilder oder ein Video',
    InstagramLimit: 'Instagram unterstützt bis zu 10 Bilder und Videos',
    seeMore: 'Mehr sehen',
    pinterestErrorTitle: 'Leider unterstützen wir nur Pinterest-Unternehmenskonten.',
    pinterestError: 'Leider können wir keine Verbindungen zu persönlichen Pinterest-Konten herstellen. Sind Sie bereit, stattdessen ein Pinterest-Geschäftskonto einzurichten? Falls es Ihnen hilft, finden Sie hier <a class="text-primary" href="{href}" target="_blank">eine Anleitung, wie Sie Ihr persönliches Konto in ein Geschäftskonto umwandeln können.</a>',
    postStatus: {
      sent: 'Gesendet',
      error: 'Fehler',
      draft: 'Entwurf',
      scheduled: 'Geplant',
    },
    publishTo: 'Veröffentlichen in',
    publishIn: 'Publish in',
    scheduleDate: 'Datum des Zeitplans',
    customizeForEach: 'Anpassen für jedes Netzwerk',
    schedulePosts: 'Planstellen festlegen',
    schedulePost: 'Planstellen festlegen',
    authorizationFailed: 'Die Autorisierung ist fehlgeschlagen. Versuchen Sie, die Anfrage zu wiederholen, indem Sie auf die Schaltfläche unten klicken',
    reauthenticate: 'Erneut authentifizieren',
    selectChannel: 'Bitte wählen Sie oben einen Kanal aus, um fortzufahren',
    workSaved: 'Ihre Arbeit wurde gespeichert',
    connectionError: 'Verbindungsfehler',
    validation: {
      minLength: 'Inhalt sollte nicht leer sein',
      maxLength: 'Beitragsgröße überschreitet die maximal zulässige Größe',
      minItems: 'Medien sollten nicht leer sein',
      maxItems: 'Zu viele Bilder für einen Beitrag',
      pattern: 'Ungültiges Dateiformat für Bild',
      linkFormat: 'Link sollte im uri-Format sein',
      mediaTypes: 'Medien können nicht gemischt werden. Wählen Sie entweder ein Bild oder ein einzelnes Video.',
      addVideo: 'Für Reels ist ein Video erforderlich, bitte fügen Sie eines hinzu',
      addItem: 'Für die Story ist ein Video oder Bild erforderlich, bitte fügen Sie eines hinzu',
      privacy: 'Datenschutz ist erforderlich',
    },
    modal: {
      authenticate: 'Authentifizieren',
      wait: 'Warum muss ich mich mit Facebook authentifizieren?',
      inOrder: 'FemTexter benötigt wichtige Genehmigungen um auf Deinen gewählten Facebook Seiten oder Gruppen für Dich Beiträge zu veröffentlichen - da dies ohne ansonsten nicht funktioniert.',
      facebookRequiresInstagram: 'Facebook verlangt von Instagram Business oder Creator Konten mit einer Facebook Seite verbunden zu sein. Damit FunKISocial einwandfrei funktionieren kann, müssen wir via Facebook authentifizieren.',
      isItSave: 'Ist das sicher?',
      whatHappensNext: 'Wie geht’s weiter?',
      restAssured: 'Keine Sorge, wir sichern Deine Daten und Zugriffe zu den Social Media Konten völlig sicher und beschützt. Zusätzlich speichern wir die Daten nur auf einem temporären Token, denn Du jederzeit in Facebook oder FemTexter mit einem Klick trennen kannst.',
      onceWeTransfer: 'Wir leiten Dich auf Facebook weiter. Melde Dich dort mit dem Facebook Profil an, dass Admin-Rechte auf der Seite hat, die mit Deinem Instagram Konto verbunden ist.',
      authenticateWithFacebook: 'Mit Facebook authentisieren',
      goToLinkedin: 'Zu LinkedIn gehen',
      beforeYouStart: 'Bevor Sie anfangen...',
      linkedinInfo: 'Wir werden Sie zu LinkedIn weiterleiten, um Ihr Konto mit femTexter zu verbinden.',
      linkedinInfoBottom: 'Wenn Sie bereits bei LinkedIn angemeldet sind, überprüfen Sie, ob Sie das richtige Konto verbinden.',
      noPagesAvailable: 'Dieses Konto hat keine gültigen Facebook Seiten.',
      noGroupsAvailable: 'Dieses Konto ist kein Administrator einer gültigen Facebook Gruppe.',
      notice: 'Anweisung',
      addToFb: '<p class="text-21-700 text-center">Füge die femTexter-App zu deiner<br/>Facebook-Gruppe hinzu</p><p>Um die Verbindung zu deiner Gruppe abzuschließen, musst du femTexter als App auf Facebook hinzufügen.</p><p>Diese Schritte musst du auf einem Computer durchführen, nicht auf einem Mobilgerät.</p><p>1. Melde dich bei deinem Facebook-Profil an, auf dem du die Admin-Rolle für die Gruppe hast, die du verbinden möchtest, und navigiere dann zu dieser Gruppe.<br/>2. Klicke auf der linken Seite auf Einstellungen.<br/>3. Finde den Abschnitt Erweiterte Einstellungen am unteren Rand der Seite und klicke dann auf das Bearbeitungssymbol rechts von Apps.<br/>4. Klicke auf Apps hinzufügen.<br/>5. Suche nach femTexter und klicke dann auf die femTexter, die in den Suchergebnissen angezeigt wird.<br/>6. Klicke anschließend auf Hinzufügen.</p><p>Gehe auf deine Gruppeneinstellungen-Seite und suche nach Erweiterte Einstellungen, um deine Apps zu bearbeiten und femTexter hinzuzufügen.</p>',
      continueWithFb: 'Weiter zu Facebook',
      instagramNoEntriesErrorTitle: 'Wir konnten keine Instagram-Konten finden, die mit diesem Konto verbunden sind.',
      instagramNoEntriesErrorDescription: 'Vergewissere dich, dass du dich mit dem Facebook-Konto anmeldest, das über Administratorrechte für das Konto verfügt, das du verbinden möchtest.<br><br>Lesen Sie mehr darüber, wie man ein <a class="text-primary" href="https://help.instagram.com/502981923235522" target="_blank">Business-konto auf Instagram einrichtet</a> und wie man die <a class="text-primary" href="https://www.facebook.com/business/help/connect-instagram-to-page" target="_blank">Facebook Business Page mit Instagram Business verbindet</a>',
    },
    scheduledInPast: 'Die geplante Zeit scheint in der Vergangenheit zu liegen',
    descriptionReduced: 'Wir kürzen die Anzahl der Zeichen in der Beschreibung auf der Grundlage des verfügbaren Zeichenlimits.',
    hasNoPermission: 'Sie haben keine Erlaubnis, einen Beitrag zu veröffentlichen.',
    needToUpdateSchedule: 'Sie müssen Ihre Aktualisierung für einen Zeitpunkt in der Zukunft planen!',
    cantConnectInstagram: 'Falls du deinen Instagram Kanal nicht verbinden kannst, findest du <a class="text-primary text-14-700" target="_blank" href="https://www.facebook.com/business/help/connect-instgram-to-page">hier</a> mögliche Gründe!<br> Schau dir alle Schritte genau an unter folgenden Link:<a class="block text-primary text-14-700" target="_blank" href="https://www.facebook.com/business/help/connect-instgram-to-page">https://www.facebook.com/business/help/connect-instgram-to-page</a> ',
    post: 'Post',
    reel: 'Reel',
    story: 'Story',
    deleteImagesReel: 'Sie müssen Bilder löschen, um einen Reel zu erstellen',
    selectPagesReel: 'Reels können nur für Facebook-Seiten erstellt werden',
    deleteImagesStory: 'Sie müssen Bilder löschen, um einen Story zu erstellen',
    deleteVideoPost: 'Nur Reels oder Story können veröffentlicht werden, wenn Videos angehängt sind.',
    destinationLink: 'Ziel-Link',
    pinningTo: 'Pinnwand auswählen',
    searchYourBoards: 'Suche in Ihren Boards',
    noBoards: 'Sieht so aus, als hätte dieses Profil noch keine Boards. Gehen Sie zum Profil und erstellen Sie Ihr erstes Board.',
    noVideoInstagramPost: 'Instagram unterstützt keine Standard-Videoposts mehr. Bitte verwenden Sie Reels oder Story zum Posten von Videos',
    noPhotoReels: 'Instagram Reel unterstützt keine Bilder. Sie können Videos in den Formaten MOV, MP4 hinzufügen.',
    noPhotoReelsFb: 'Facebook Reel unterstützt keine Bilder. Sie können Videos in den Formaten MOV, MP4 hinzufügen.',
    noPhotoShorts: 'YouTube shorts unterstützt keine Bilder. Sie können Videos in den Formaten MOV, MP4 hinzufügen.',
    disableComments: 'Kommentar',
    tiktokPrivacy: {
      publicToEveryone: 'Öffentlich für alle',
      mutualFollowFriends: 'Nur für Follower',
      followerOrCreator: 'Follower oder Creator',
      selfOnly: 'Nur für mich Sichtbar',
    },
    privacy: 'Privatsphäre',
    postWillBePosted: 'Der Beitrag wird in naher Zukunft veröffentlicht',
    toConnectInstagramAccount: 'Um ein Instagram-Account zu verbinden, verlangt Facebook, dass <span class="text-black">Instagram Business- oder Creator-Account mit einer Facebook-Seite verbunden werden.</span> Damit FunKISocial wie vorgesehen funktioniert, müssen wir uns über Facebook authentifizieren.',
    readMoreAboutInstagramBusiness: 'Erfahre mehr über <a href="https://help.instagram.com/138925576505882" target="__blank" class="text-primary">Instagram Business oder Creator Accounts auf Instagram.</a>',
    makeSureYouAreSigningInInstagram: 'Bitte stelle sicher, dass du mit dem <span class="text-black">persönlichen Facebook-Profil eingeloggt bist, welches Admin-Rechte für die mit Instagram Business oder Creator verbundene Seite hat,</span> die du verbinden möchtest.',
    error: {
      bannedFromPosting: 'TikTok lässt nicht zu, dass dieser Beitrag veröffentlicht wird, da das TikTok-Konto gesperrt ist.',
      tooManyPosts: 'Die tägliche Beitragsobergrenze aus der API ist für den aktuellen Benutzer erreicht.',
      reachedCap: 'Die tägliche Quote für aktive Veröffentlichungsbenutzer aus Ihrem Mandanten ist erreicht.',
    },
  },
  auth: {
    signInToFunKITools: 'Login in FunKITools',
    email: 'Email',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    signIn: 'Login',
    forgotPassword: 'Passwort vergessen?',
    restore: 'Zurücksetzen',
    newUser: 'Neuer Nutzer?',
    createAccount: 'Account erstellen',
    alreadyHaveAnAccount: 'Du hast bereits einen Account?',
    getOneFreeMinutes: 'Erhalte 1 Freiminute:',
    signUpNow: 'Jetzt registrieren!',
    registration: 'Registrierung',
    byContinuingYouAgreeTo: 'Wenn du fortfährst, erklärst du dich damit einverstanden',
    termsOfUse: 'Nutzungsrichtlinien',
    and: 'und',
    privacyPolicy: 'Datenschutzrichtlinien',
    forgotYourPassword: 'Passwort vergessen?',
    enterYourEmailToResetPassword: 'Gib deine Email Adresse ein, um dein Passwort zurückzusetzen',
    sendEmail: 'Email senden',
    back: 'Zurück',
    createNewPassword: 'Neues Passwort festlegen',
    yourNewPassword: 'Dein neues Passwort muss sich von deinen zuvor genutzten Passwörtern unterscheiden',
    restorePassword: 'Passwort zurücksetzen',
    imprint: 'Impressum',
    checkYourMail: 'Checke dein Postfach',
    weSentPassword: 'Wir haben dir eine Anleitung zum Zurücksetzen des Passworts an deine Email gesendet',
    passwordChanged: 'Passwort erfolgreich zurückgesetzt',
    login: 'Login',
    withNewPassword: 'mit neuem Passwort',
  },
  text: {
    rating: 'Bewertung',
    currentText: 'Current text',
    generatedText: 'Generated text',
    uploadCoverBook: 'Upload cover book',
    whatIsThisBookAbout: 'Worum geht es in diesem PDF',
    youWillLoggedOut: 'Du wirst gleich ausgeloggt...',
    weSentNotificationWithConfirmLink: 'Wir haben eine Bestätigunsmail an deine Email geschickt',
    copyrightAllRightsReserved: 'Copyright. All Rights Reserved',
    checkYourEntry: 'Möglicherweise ist ein Fehler unterlaufen. Bitte überprüfe die Schreibweise.',
    loginTourAccount: 'oder logge dich in <a class="link-color cursor-pointer" href="{href}" target="_blank">deinen Account</a> ein',
    checkInbox: 'Checke deinen Posteingang und folge der Anleitung',
    youCanChangeTheCoverStyle: 'Sie können den Cover-Stil ändern',
    newBookWithAI: 'Neues PDF mit KI',
    yourBook: 'Dein PDF',
    clickOnThePaletteIcon: 'Klicken Sie auf das Palettensymbol',
    deleteAutoresponderConfirm: 'Autoresponder aus diesm Formular löschen?',
    exportContacts: 'Kontakte exportieren.',
    youDontHaveLeads: 'You don\'t have any leads yet',
    fillOutTheBlog: 'Fill out the blog, post and enable subscription and the service will start collecting leads',
    customFont: 'Benutzerdefinierte Schriftart',
    theseAreTheSuggestedChaptersOfYourBook: 'Du siehst nun die vorgeschlagenen Kapitel deines PDF. Du kannst diese hier ändern oder neue hinzufügen bzw löschen.',
    generatedChaptersNumber: 'Die Anzahl der generierten Kapitel kann von der gewünschten Anzahl abweichen.',
    emails: 'E-Mails',
    titleLockScreen: 'Titelsperrbildschirm',
    descriptionLockScreen: 'Beschreibung Sperrbildschirm',
    payment: 'Zahlung',
    productDefault: 'Produktstandard',
    background: 'Hintergrund',
    paywall: 'Paywall',
    customDomain: 'Benutzerdefinierte Domain',
    freeBook: 'Gratis PDF',
    generalColor: 'Allgemeine Farben',
    shareToUnlock: 'Zum Entsperren teilen',
    dragOrClickToLoadImage: 'Ziehen oder <span>klicken</span> Sie, um das Bild zu laden',
    clickToLoadImage: '<span>Klicken Sie</span>, um das Bild zu laden',
    addUserToSpreadSheet: 'Füge diesen Benutzer "<b>{0}</b>" zu deiner Google Tabelle mit "Darf Bearbeiten" Berechtigung hinzu',
    codeCopiedSuccessfully: 'Code erfolgreich kopiert',
    textCopiedSuccessfully: 'Text erfolgreich kopiert',
    urlCopiedSuccessfully: 'URL erfolgreich kopiert',
    noSalesYet: 'Noch keine Verkäufe',
    yourBookHasNoSales: 'Ihr PDF hat noch keine aktiven Verkäufe\'',
    pleaseFixErrors: 'Bitte beheben Sie Validierungsfehler für jedes ausgewählte Netzwerk',
    ifYouHavePinterestAccount: 'Wenn du ein <a href="https://help.pinterest.com/en/article/switch-between-accounts" target="__blank" class="text-primary">Pinterest-Business-Konto hast, das mit deinem persönlichen Pinterest-Konto verknüpft ist</a>, musst du dich zuerst bei Pinterest anmelden und sicherstellen, dass das Konto, das du mit FunKISocial verbinden möchtest, im Dropdown-Menü in der oberen rechten Ecke von Pinterest ausgewählt ist.',
    onceYouTheCorrect: 'Sobald das richtige Konto ausgewählt ist, kannst du zu FunKISocial zurückkehren, um das Pinterest-Konto zu verbinden.',
    letsConnect: 'Verbinden wir uns',
    emptyMentions: 'Tut mir leid, es scheint keine Beiträge für solche Filter zu geben. Versuchen Sie, die Filter zu ändern oder Instant Fetch in den erweiterten Einstellungen auszuführen.',
    selectSocialMedia: 'Wählen Sie die sozialen Medien aus, in denen Sie relevante Beiträge sehen möchten',
    error: 'Fehler',
    repliesDesc: 'Hier sind alle Ihre Antworten, die Sie nicht bereits als "Geantwortet" markiert haben',
    repliedDesc: 'Hier sind alle Ihre Antworten, die Sie als "Geantwortet" markiert haben',
    artificialIntelligenceInCopywriting: 'Künstliche Intelligenz im Copywriting',
    generatingPicture: 'Bild wird erstellt',
    moveFileHereToUpload: 'Verschieben Sie die Datei hierher, um sie hochzuladen',
    deleteConfirm: 'Möchtest du "<b>{0}</b>" löschen?',
    files: 'Dateien | Datei | Dateien',
    inputs: 'Eingaben',
    postCreated: 'Beitrag erstellt',
    postDeleted: 'Beitrag gelöscht',
    postUpdated: 'Post aktualisiert',
    seeYourPostPreview: 'Sehen Sie hier die Vorschau Ihres Posts',
    used: 'used',
    forDays: 'für {n} Tage',
    timesOnce: 'einmalig',
    viewPlanInfo: 'Plan ansehen',
    funkitoolsBranding: 'FunKITools-Branding',
    youCantRemoveBranding: 'Du kannst das FunKITools-Branding <br> nicht entfernen',
    removeBranding: 'FunKITools-Branding entfernen',
    nothingWasFound: 'Wir konnten nichts finden',
    tryAgain: 'Erneut versuchen',
    leads: 'Kontakte',
    smtpSubtitle: 'Unser System versendet E-Mails per „Standard-SMTP“. Um eine eigene E-Mail-Adresse und eine bessere Zustellrate zu erhalten, kannst du dein eigenes SMTP aktivieren. Um dein eigenes SMTP zu verwenden, musst du „Standard-SMTP“ deaktivieren. WICHTIG: Verwende Port 587 für den Postausgangsserver.',
    noConnectedAutoresponder: 'Du hast noch keine <br> Autoresponder verbunden',
    autoresponderSubtitle: 'Hier kannst du eine Integration mit einem externen Autoresponder erstellen (Klicktipp, Getresponse, Mailchimp...).',
    googleSpreadsheetAddUser: 'Füge diesen Benutzer "{email}" zu deiner Google Tabelle mit "Darf Bearbeiten" Berechtigung hinzu',
    autoresponderAddedSubtitle: 'Jetzt können Sie es für Anmeldeformulare verwenden.',
    autoresponderAddedTitle: '{autoresponder} erfolgreich <br> hinzugefügt',
    tableContent: 'Inhaltsverzeichnis',
    reduceNumberOfCharacters: 'Verringern Sie die Anzahl der Zeichen für die Verwendung von Magic',
    toneOfVoice: 'Tonalität',
    link: 'link',
    onlyDesktop: 'Bitte nutzen Sie einen PC oder ein Tablet, um FunKlTools zu nutzen. Die mobile Version ist in Arbeit',
    recommendToUseCloudFlare: 'Wir empfehlen, CloudFlare für das Verbinden einer Domain zu nutzen',
    cloudFlare: 'CloudFlare (Haupt-Domain verbinden):',
    delegateDomainToCloudFlare: '1. Domain mit Cloudflare verbinden (Überspringe diesen Schritt, wenn deine Domain bereits mit Cloudflare verbunden ist)',
    waitingForDnsUpdate: '2. Warten auf DNS Update (Überspringe diesen Schritt, wenn deine Domain bereits mit Cloudflare verbunden ist)',
    goToDnsSettings: '3. Gehe zu DNS Einstellungen',
    clickAddRecord: '4. Klicke “Eintrag hinzufügen” und füge diese Daten hinzu:',
    addDomainInAffilipage: '5. Füge die Domain in FunKITools hinzu',
    otherProviders: 'Andere Anbieter (Subdomain):',
    settingsDesc: 'Mach deinen Blog wahrlich einzigartig und passe Einstellungen nach deinen Belieben an. Du kannst Tracking Codes anpassen, eine benutzerdefinierte Domain nutzen und das Design deines Blogs individualisieren. Starte am besten sofort!',
    addSubdomainInYourDomain: '1. Füge eine Subdomain (CNAME) in deinem DNS Manager hinzu',
    forExample: `Beispiel: www points to ${process.env.CONNECT_DOMAIN}`,
    addDomain: '2. Füge die Domain in FunKITools hinzu',
    noResults: 'Keine Resultate',
    requests: 'Anfragen',
    leftOutOf: 'von',
    dateUntil: 'bis zum <span class="text-black q-ml-xs">{date}</span> übrig',
    theRequestLimitHasBeenReached: 'Du hast dein Limit bereits erreicht. Bitte aktualisiere deinen Tariff',
    keywordSearchesUsed: 'Keywort Recherchen genutzt',
    postGenerationUsed: 'Blogbeitrag Erstellungen genutzt',
    dateUpdatingLimits: 'Wird an diesem Datum zurückgesetzt',
    sorryPageNotFound: 'Entschuldige, die abgefragte Seite wurde nicht gefunden',
    namecheap: 'Namecheap (Haupt-Domain verbinden)',
    navigateToTheDomains: '1. Navigiere zum "Domains" Menüpunkt in deinem FunKITools Dashboard und klicke auf "Neue Domain hinzufügen" (Überspringe diesen Schritt, wenn deine Domain bereits mit FunKITools verbunden ist).',
    enterTheName: '2. Gib den Namen der Domain ein, die du verbinden willst. Das folgende Format ist erforderlich, "meinedomain.com". Du wirst jetzt einen "DNS Eintrag" sehen, welchen du in Namecheap erstellen musst.',
    logInToYourNamecheap: '3. Logge dich in deinen Namecheap Account ein.',
    selectDomainList: '4. Wähle "Domain List" in der linken Menüleiste und klicke auf den "Manage" Button neben dem gewünschten Domain-Namen.',
    clickOnTheAdvancedDns: '5. Klicke auf den "Advanced DNS" Tab und finde die "Host records" Sektion. Klicke dort auf "Add new Record".',
    nowSelectCnameRecord: `6. Wähle jetzt "CNAME Record" und gib bei "Host" ein: {'@'}, für "Value": ${process.env.CONNECT_DOMAIN} Und setze TTL auf: "Automatic".`,
    notice: 'Anmerkung:',
    itMayTakeUp: 'Es kann bis zu 48 Stunden dauern, bis die Domain Einstellungen vollständig übernommen werden.',
    namecheapSubdomain: 'Namecheap (Subdomain verbinden)',
    connectSubdomainNamecheap: 'Um eine Subdomain mit FunKITools über Namecheap zu verbinden, folge den ersten 4 Schritten aus der Anleitung zu "Haupt-Domain verbinden".',
    godaddyConnectMainDomain: 'Godaddy (Haupt-Domain verbinden)',
    logInToYourGodaddy: '3. Logge dich in deinen Godaddy Account ein.',
    clickOnTheUserProfile: '4. Klicke auf das Benutzerprofil-Symbol in der oberen rechten Ecke und wähle "Meine Produkte" aus.',
    clickOnDns: '5. Klicke auf DNS rechts neben deine Domain.',
    clickOnAdd: '6. Klicke auf "Hinzufügen" rechts unten und wähle "CNAME".',
    inTheHostField: `7. Gib im Feld "Host" folgenden Wert ein: {'@'}, für "Value": ${process.env.CONNECT_DOMAIN} und setze TTL auf: "Automatic."`,
    godaddyConnectSubdomain: 'Godaddy (Subdomain verbinden)',
    enterTheNameOfTheDomain: '2. Gib den Namen der Domain ein, die du verbinden möchtest. Das folgende Format ist erforderlich, "meinedomain.com". Du wirst jetzt einen "DNS Eintrag" sehen, welchen du in Namecheap erstellen musst.',
    toConnectSubdomain: 'Um eine Subdomain mit FunKITools über Godaddy zu verbinden, folge den ersten 5 Schritten aus der Anleitung zu "Haupt-Domain verbinden".',
    nowCreate: '1. Jetzt erstelle (falls noch kein Subdomain Eintrag besteht) oder bearbeite (falls ein Subdomain Eintrag bereits besteht) den CNAME Eintrag mit den folgenden Parametern:',
    hostTheName: 'Host: der Name deiner Subdomain',
    valueConnect: `Value: ${process.env.CONNECT_DOMAIN}.`,
    ttlAutomatic: 'TTL: "Automatic"',
    ionosConnectMainDomain: 'Ionos (Haupt-Domain verbinden)',
    enterTheNameOfTheDomainIonos: '2. Gib den Namen der Domain ein, die du verbinden möchtest. Das folgende Format ist erforderlich, "meinedomain.com". Du wirst jetzt einen "DNS Eintrag" sehen, welchen du in Ionos erstellen musst.',
    logYourIonos: '3. Logge dich in deinen Ionos Account ein.',
    clickSettingsIcon: '4. Klicke auf das Einstellungssymbol für deine Domain und dann auf DNS.',
    clickAddRecordCname: '5. Klicke jetzt auf "Add Record" und wähle "CNAME".',
    enterFieldHostname: `6. Gib im Feld Hostname folgenden Wert ein: {'@'}, für Value (Points to): ${process.env.CONNECT_DOMAIN} und setze TTL auf: "Automatic."`,
    ionosConnectSubdomain: 'Ionos (Subdomain verbinden)',
    connectSubdomain: 'To connect a subdomain to FunKItolls via Ionos, follow the first 4 steps of setup for a "main" domain.',
    hostname: 'Hostname: Der Name deiner Subdomain',
    valuePoints: `Value (Points to): ${process.env.CONNECT_DOMAIN}.`,
    stratoConnectMainDomain: 'Strato (Haupt-Domain verbinden)',
    enterNameDomainStrato: '2. Gib den Namen der Domain ein, die du verbinden möchtest. Das folgende Format ist erforderlich, "meinedomain.com". Du wirst jetzt einen "DNS Eintrag" sehen, welchen du in Strato erstellen musst.',
    logStrato: '3. Logge dich in deinen Strato Account ein.',
    clickManageDomains: '4. Klicke auf Domains verwalten.',
    clickNextDomain: '5. Klicke neben deiner Domain auf verwalten.',
    clickDnsSettings: '6. Klicke jetzt auf DNS Einstellungen.',
    clickManageCname: '7. Klicke auf CNAME Record verwalten.',
    enterFollowing: `8. Gib den folgenden Wert im Feld ein: ${process.env.CONNECT_DOMAIN} & klicke auf "Einstellungen anwenden".`,
    stratoConnectSubdomain: 'Strato (Subdomain verbinden)',
    connectSubdomainStrato: 'Um eine Subdomain mit FunKITools über Strato zu verbinden, folge den ersten 4 Schritten aus der Anleitung zu "Haupt-Domain verbinden".',
    clickSymbolNextDomain: '1. Klicke auf das + Symbol neben deiner Domain, um die zweite Zeile zu öffnen.',
    clickManageSecondLine: '2. Klicke jetzt auf Manage in der zweiten Zeile.',
    listSettingsDnsManagement: '3. Öffne das Feld DNS Management in den Listen-Einstellungen (Subdomain).',
    clickManageRecord: '4. Klicke auf Manage CNAME record.',
    enterFollowingIntoField: `5. Gib den folgenden Wert im Feld ein: ${process.env.CONNECT_DOMAIN} & Klicke auf "Einstellungen anwenden".`,
    sitegroundMainDomain: 'Siteground (Haupt-Domain verbinden)',
    enterNameDomainSiteground: '2. Gib den Namen der Domain ein, die du verbinden möchtest. Das folgende Format ist erforderlich, "meinedomain.com". Du wirst jetzt einen "DNS Eintrag" sehen, welchen du in Siteground erstellen musst.',
    logSiteground: '3. Logge dich in deinen Siteground Account ein.',
    navigateSiteTools: '4. Navigiere zu Site Tools > Domain > DNS Zone Editor.',
    clickCreateNewRecord: '5. Klicke auf Create New Record und wähle CNAME.',
    selectNameField: `6. Gib im Select Name Feld folgenden Wert ein: {'@'}, für iPv4 Address: ${process.env.CONNECT_DOMAIN} und setze TTL auf: "Automatic".`,
    finallyCreate: '7. Klicke anschließend auf Create.',
    sitegroundSubdomain: 'Siteground (Subdomain verbinden)',
    connectSubdomainSiteground: 'Um eine Subdomain mit FunKITools über Siteground zu verbinden, folge den ersten 4 Schritten aus der Anleitung zu "Haupt-Domain verbinden".',
    createOrEdit: '1. Erstelle (falls noch kein Subdomain Eintrag besteht) oder bearbeite (falls ein Subdomain Eintrag bereits besteht) den CNAME Eintrag mit den folgenden Parametern:',
    selectNameYourSubdomain: 'Namen wählen: Der Name deiner Subdomain',
    addressConnectAffilipage: `iPv4 Address: ${process.env.CONNECT_DOMAIN}`,
    allInklMainDomain: 'All-inkl (Haupt-Domain verbinden)',
    enterNameAllInkl: '2. Gib den Namen der Domain ein, die du verbinden möchtest. Das folgende Format ist erforderlich, "meinedomain.com". Du wirst jetzt einen "DNS Eintrag" sehen, welchen du in All-Inkl erstellen musst.',
    logAllInkl: '3. Logge dich in deinen All-Inkl Account ein.',
    technicalAdministration: '4. Navigiere über die Menü-Links zu "Technische Administration".',
    clickOnKasLogin: '5. Klicke auf "KAS Login" auf der rechten Seite.',
    clickDomainLinks: '6. Klicke auf "Domain" im Link-Menü.',
    DnsSettingsDomain: '7. Klicke rechts neben deiner Domain auf "Bearbeiten" und anschließend unten auf "DNS Einstellungen für diese Domain".',
    clickCreateNewDnsEntry: '8. Klicke auf "Neuen DNS Eintrag erstellen" und wähle CNAME als "Typ".',
    enterFieldNameData: `9. Gib im Feld Name den folgenden Wert ein: {'@'} und für Data: ${process.env.CONNECT_DOMAIN}.`,
    itMayTakeUpWorldwide: 'Es kann bis zu 48 Stunden dauern, bis die Domain Einstellungen vollständig übernommen werden.',
    allInkSubdomain: 'All-inkl (Subdomain verbinden)',
    connectSubdomainAllInkl: 'Um eine Subdomain mit FunKITools über Siteground zu verbinden, folge den ersten 7 Schritten aus der Anleitung zu "Haupt-Domain verbinden.',
    nameYourSubdomain: 'Name: Der Name deiner Subdomain',
    dataConnectAffilipage: `Data: ${process.env.CONNECT_DOMAIN}.`,
    reachable: 'Erreichbar',
    sslConnected: 'SSL verbunden',
    domainDisconnected: 'Domain getrennt',
    noReachable: 'Nicht erreichbar',
    sslDisconnected: 'SSL getrennt',
    domainPageHint: 'Du kannst deine Domains an deine Funnels anhängen. Falls du Hilfe brauchst, sie dir unser {0} auf "Domain hinzufügen" an.',
    instructions: 'Anleitungen',
    type: 'Typ:',
    cname: 'CNAME',
    name: 'NAME: {\'@\'}',
    target: 'Ziel:',
    proxyStatus: 'Proxy Status:',
    off: 'Aus',
    ttl: 'TTL:',
    auto: 'Auto',
    postTitlePlaceholder: 'e.g. Gießen in Perfektion: Entdecke die reiche Welt des Rotweins',
    postTitleTip: 'Leer lassen, um KI generieren zu lassen',
    connectDomain: `${process.env.CONNECT_DOMAIN}`,
    attention: 'Aufgepasst',
    resetStylesToDefault: 'Möchtest du die Styles auf Standard zurücksetzen <br>?',
    beCarefulThisAction: 'Sei vorsichtig mit dieser Aktion, <br> sie kann nicht rückgängig gemacht werden',
    content: 'Content',
    words: 'Wörter',
    uploadFavicon: 'Upload Favicon',
    amongTheMostCrucial: 'Eines der wichtigsten Elemente der <br> SEO ist ein aussagekräftiger Titel, der der Suchabsicht des Nutzers entspricht.',
    goodMetaDescription: 'Eine gute Meta-Beschreibung ist eine kurze Zusammenfassung, die darauf <br> abzielt,  die Nutzer in den Suchergebnissen zum Klicken zu verleiten.',
    contentShouldBeSimilar: 'Der Inhalt sollte ähnlich lang sein wie der von Wettbewerbern\' aber dennoch prägnant und informativ.',
    unfortunatelyPageNotFound: 'Leider wurde die Seite nicht gefunden oder an einen anderen Ort verschoben.',
    returnToThe: 'Zurückkehren zu',
    mainPage: 'Hauptseite',
    homePage: 'Startseite',
    orContactSupport: 'oder kontaktiere den Support',
    returnToDashboard: 'Zurück zum Dashboard',
    returnToHomepage: 'Zur Startseite zurückkehren',
    contentRecommendation: 'Content Empfehlungen',
    recommendedWordCount: 'Empfohlene Wörteranzahl',
    editTemplate: 'Template bearbeiten',
    comingSoon: 'Coming <br> soon',
    viewAll: 'Alle ansehen',
    articleSettings: 'Artikel Einstellungen',
    doYouWantToDelete: 'Möchtest du <br> {name} löschen?',
    createNewContent: 'Neuen Content erstellen',
    adjustTheOutline: 'Passe die Gliederung vor der Generierung von Inhalten für das Keyword <br> an ',
    generatingOutline: 'Gliederung erstellen...',
    subheadings: 'Zwischenüberschrift',
    domainAdded: 'Domain erfolgreich hinzugefügt <br>',
    domainAddedSubtitle: 'Deine Domain wurde hinzugefügt <br> und wird in Kürze verfügbar sein',
    howToConnectDomain: 'Wie verbinde ich eine Domain?',
    domainIsNotConnected: `Domain ist nicht verbunden. <br> Bitte prüfen deine DNS Einstellungen, ob deine Domain<br> auf "${process.env.CONNECT_DOMAIN}" zeigt`,
    domainConnected: 'Domain verbunden',
    sslIsNotConnected: 'SSL ist nicht verbunden',
    createLink: 'Link erstellen',
    externalUrl: 'Externe URL',
    internalUrl: 'Interne URL',
    connectingYourDomain: 'Deine Domain wird verbunden',
    helpCenter: 'Hilfecenter',
    keywordDistribution: 'Keyword Verteilung',
    distributionOfTheMainKeyword: 'Dies ist die Verteilung des Hauptkeywords auf <br> die 10 wichtigsten Suchergebnisse für das Zielkeyword',
    image: 'Bild',
    metaDescription: 'Meta Beschreibung',
    metaKeywords: 'Meta Keywords',
    titleCompetitive: 'Wettbewerbsfähigkeits-Score des Titels (tcs)',
    settings: 'Einstellungen',
    noSSL: 'Kein SSL',
    uploadYourOwnImage: 'Lade deine eigenes Bild hoch',
    editLink: 'Link bearbeiten',
    viewLink: 'Link ansehen',
    copyUrl: 'URL kopieren',
    uploadingAnImage: 'Bild wird hochgeladen',
    pleaseWait: 'Bitte warten',
    changeImage: 'Bild ändern',
    dragOrClickToChangeThePicture: 'Ziehe oder klicke auf <br>, um das Bild zu ändern',
    uploadFile: 'Datei hochladen',
    uploadFromCloud: 'Aus der Cloud hochladen',
    addHeading: 'Überschrift hinzufügen',
    templatePreview: 'Template Vorschau',
    noConnectedDomains: 'Du hast<br> keine verbundenen Domains',
    noConnectedDomainsSubtitle: 'Verbinde zunächst eine Domain mit deinem Blog. Anschließend wird sie in der Übersicht angezeigt.',
    yourDocumentReady: 'Dein Dokument ist fertig!',
    targetKeyword: 'Zielkeyword',
    writeAndAnalyze: 'Schreibe und analysiere...',
    identifyingSearchIntents: 'Identifiziere Suchabsichten...',
    aiExplorer: 'KI Explorer',
    myKeywords: 'Meine Keywords',
    searchOrKey: 'Suche oder Schlüssel',
    typeSeedKeywordOrDescription: 'Gib das Haupt-Keyword oder eine Beschreibung <br> ein und finde weitere Keywords',
    setTheDefaultLanguage: 'Stelle die Standard-Sprache für das System ein.',
    noArticle: 'Noch keine Artikel vorhanden',
    noArticleDescription: 'Vielleicht hat der Autor die Artikel noch nicht <br> gekennzeichnet',
    exampleKeyword: 'Gib das Keyword ein, um danach zu suchen',
    characters: 'zeichen',
    you: 'Du',
    myDomains: 'Meine Domains',
    addUrl: 'URL hinzufügen',
    whatsNew: 'What\'s new?',
    new: 'new',
    emptyBrandVoiceSubtitle: 'Beginne mit der Erstellung deiner Markenstimme. Klicke einfach auf "Neue Stimme".',
    brandVoiceSubtitle: 'Deine Markenstimme ermöglicht FunKITools den Zugriff auf einzigartige Informationen zu dem, was du schreibst, sowie auf deinen spezifischen Ton und Stil, den du verwendest. Dadurch wird sichergestellt, dass jeder von dir erstellte Inhalt auch genau deinem Stil entspricht. Gib zunächst Hintergrundinformationen zu den von dir erstellten Inhalten an.',
    noConnectedVoice: 'Du hast keine verbundene Markenstimme',
    pasteAnyText: 'Füge hier einen individuellen Text ein, der deinen eigenen unverwechselbaren Stil perfekt widergibt.',
    brandedText: 'Branded text',
    foxNews: 'e.g. FoxNews',
    modifyBrandVoice: 'Ändern Sie Ihre Markenstimme',
    thisIsBrandVoiceInfo: 'Dies ist die Markenstimme, die femTexter aus Ihren hochgeladenen Inhalten synthetisiert hat.',
    voiceAdded: 'Markenstimme erfolgreich hinzugefügt',
    voiceAddedSubtitle: 'Jetzt können Sie sie zur Erstellung von Inhalten verwenden.',
    internalServerError: 'Internal server error',
    copyAsText: 'Text kopieren',
    copyAsHtml: 'HTML kopieren',
    markdown: 'Markdown',
    doYouWantToCollect: 'Du möchtest Kontakte sammeln?',
    youWillBeAbleToSend: 'Du kannst E-Mail-Ketten an deine Kontakte senden und sie bspw. über neue Beiträge informieren.',
    enableNewsletter: 'Newsletter aktivieren',
    notSelected: 'Nicht ausgewählt',
    youCanCustomizeDescription: 'Du kannst auch das Anmeldeformular anpassen',
    youCanChangeTheDescription: 'Ändere die Beschreibungen und vieles <br> mehr in',
    customDesign: 'Benutzerdefiniertes Design',
    addNewAutoresponder: 'Neuer Autoresponder',
    addNewEmailChain: 'Neue Emailserie hinzufügen',
    email_one: 'email',
    email_other: 'E-mail',
    pageTitlePlaceholder: 'e.g. Impressum',
    pageSlugPlaceholder: 'e.g. impressum',
    yourPageTitleHere: 'Ihr Seitentitel hier',
    fillInTheFieldsOnTheLeft: 'Füllen Sie die Felder auf der linken Seite des Bildschirms aus und beginnen Sie dann mit der Erstellung des Seiteninhalts',
    useCreated: 'Use created',
    newPage: 'New page',
    previewNewTab: 'Preview new tab',
    yourEmail: 'Ihre E-Mail',
    byClickingSubscribe: 'Durch Anklicken des Buttons erklären Sie sich mit dem',
    dataProcessingRules: 'Datenschutz',
    successful: 'Erfolgreich',
    youHaveSubscribed: 'Sie haben sich erfolgreich <br> abonniert',
    youWillReceiveNews: 'Sie werden neue E-Mails erhalten an <br>',
    noConnectedEmailChains: 'Du hast noch keine <br> Emailserie',
    emailChainsSubtitle: 'Hier kannst du E-Mail Serien erstellen, die mit unserem Autoresponder versendet werden. Du kannst eine bereits erstellte Emailserie verwenden.',
    email: '{n} E-mails | {n} E-mail | {n} E-mails',
    emailChain: 'Email chain',
    emailChainAdded: 'Emailserie erfolgreich <br> hinzugefügt',
    emailChainAddedSubtitle: 'Sie müssen sie nur noch in den Blog Einstellungen im Abschnitt Newsletter auswählen.',
    willBeSentVia: 'wird gesendet über',
    hour: '{n} hours | {n} hour | {n} hours',
    day: '{n} Tagen | {n} Tage | {n} Tagen',
    editMail: 'E-Mail bearbeiten',
    previewMail: 'E-Mail vorschau',
    duplicateMail: 'E-Mail duplizieren',
    deleteMail: 'E-Mail löschen',
    hours: 'Hours',
    seconds: 'Seconds',
    days: 'Tagen',
    minutes: 'Minuten',
    defaultSmtp: 'Standard-SMTP',
    youAreUsingDefaultSmtp: 'Du verwendest Standard-SMTP',
    byDefaultSmtpDesc: 'Unser System versendet E-Mails per „Standard-SMTP“. Um eine eigene E-Mail-Adresse und eine bessere Zustellrate zu erhalten, kannst du dein eigenes SMTP aktivieren. Um dein eigenes SMTP zu verwenden, musst du „Standard-SMTP“ deaktivieren. WICHTIG: Verwende Port 587 für den Postausgangsserver.',
    helpIsNeeded: 'Hilfe wird benötigt?',
    writeToOurAssistent: 'Schreiben Sie unserem Assistenten, er wird Ihnen alles beantworten',
    write: 'Schreiben',
    none: 'None',
    enableDoi: 'Enable DOI',
    addHeaders: 'Headers hinzufügen',
    selectSomeText: 'Wählen Sie einen Text für die Verwendung von Magic',
    videoEmbed: 'Video einbetten',
    videoEmbedPlaceholder: 'z.B. https://www.youtube.com/embed/sss?si=jdsj',
    selectBrandVoice: 'Select brand voice',
    generateWithAI: 'Mit KI generieren',
    removeImage: 'Bild löschen',
    sitemapInProcess: 'Die Sitemap wird gerade erstellt',
    sitemapGenerationWillTakeTime: 'Die Erstellung der Sitemap wird einige Zeit in Anspruch nehmen. Sobald sie erstellt ist, wird hier eine Schaltfläche mit einem Download-Link angezeigt.',
    willBeGenerated: 'Wird generiert',
    thisIsYourSitemap: 'Dies ist die Sitemap Ihres Blogs',
    hereYouCanDownloadSitemap: 'Hier können Sie die Sitemap herunterladen und dort platzieren, wo Sie sie benötigen, zum Beispiel in der Google Search Console',
    myBlogs: 'Meine Blogs',
    addNewBlog: 'Neuen Blog hinzufügen',
    blogsHaveBeenCreated: '{uses} von {limit} Blogs wurden erstellt.',
    blogsLimitReached: '{uses} von {limit} Blogs wurden erstellt. Um mehr Blogs zu erstellen, aktualisieren Sie den Tarif.',
    youCreatingEmptyPost: 'Sie erstellen einen leeren Beitrag',
    ifYouNeedHelpFromAI: 'Wenn Sie die Hilfe von AI benötigen, gehen Sie zur Erstellung mit AI',
    youHaveReachedLimit: 'Sie haben Ihr Limit für die Erstellung von Blogs erreicht. Aktualisieren Sie Ihren Tarif, um mehr Blogs zu erstellen.',
    firstWriteText: 'Schreiben Sie zuerst den Text (min 500 Wörter) des Beitrags und starten Sie dann die Analyse.',
    noinexTooltip: 'Wenn diese Option aktiviert ist, wird die Seite nicht von Suchmaschinen indiziert.',
    synchronizeThePost: 'Synchronisiere den Beitrag mit deiner Webseite',
    hereAreTheWebsites: 'Hier findest du deine Webseiten mit denen du diesen Beitrag synchronisieren kannst',
    noSitesFound: 'Keine Websites gefunden',
    makeSureThatYouHavePlugin: 'Stell sicher, dass du das FunKITools Plugin auf deiner Webseite installiert hast und den Schlüssel in den Plugin Einstellungen richtig gesetzt hast.',
    syncing: 'Synchronisiert...',
    notSynchronized: 'Nicht synchronisiert',
    successfully: 'Das hat geklappt',
    syncingFailed: 'Synchronisierung fehlgeschlagen',
    weRecommendHidingPosts: 'Wir raten dazu Beiträge auf externen Seiten vor Suchmaschinen zu verstecken oder sie unveröffentlicht zu lassen. Klicke auf das Zahnrad im obersten Menüpunkt des Editors und aktiviere die "Keine Indexierung" Option um deine Beiträge von Indexing zu verstecken.',
    doYouWantTosynchronizePost: 'Möchten Sie den Beitrag mit {website} synchronisieren?',
    peopleAlsoAskLegend: 'Die "Ähnliche Fragen"-Fragen basieren auf der SERP für das Ziel-Keyword.',
    aiQuestionsLegend: 'Fragen, die über KI Analyse zu Ihrem Ziel-Keyword basieren.',
    confirmAccountDeletion: 'Bestätigung der Kontolöschung',
    noAccountRestore: 'Bitte beachten Sie, dass es nicht möglich ist, Ihr Konto wiederherzustellen.',
    relatedQuestionsDescription: 'Das Einbeziehen von Googles "Ähnliche Fragen"-Fragen ist ein ausgezeichneter Ausgangspunkt für Inhalte.',
    nofollowTooltip: 'NoFollow-Links sind Links, die mit dem Attribut rel="nofollow" versehen sind. Das "nofollow" Attribut weist Suchmaschinen an, diesen Link zu ignorieren.',
    metaTagFieldDescription: 'Eine der obligatorischen Anforderungen für das Einfügen von Meta-Tags ist das Anführungszeichenformat. Verwende keine schrägen Anführungszeichen wie (”), sondern (").',
    noAccessToPlugin: 'Kein Zugang zur <br> WordPress Plugin',
    updateYourPlan: 'Upgrade deinen Plan <br> um alle Funktionen zu nutzen',
    noAccessToSyncing: 'Kein Zugang zur <br> Synchronisierung mit WordPress',
    doYouWantToDeleteAllRecords: 'Möchten Sie alle Einträge aus Ihrem Suchverlauf löschen?',
    doYouWantToDeleteSingleRecord: 'Möchten Sie den Schlüsselwortverlauf für die Abfrage „{seed}“ löschen?',
    noAccessTo: 'Kein Zugang zur <br> {feature}',
    noAccessToUse: 'Kein Zugang zur Nutzung von {feature}',
    keywords: '{n} keywords | {n} keyword | {n} keywords',
    addedToFavourite: 'Zu Favoriten hinzugefügt',
    notAvailableInCurrentPlan: 'Nicht verfügbar im aktuellen Plan',
    noAccessToThisTemplate: 'Diese Vorlage ist nicht <br> verfügbar',
    noAccessToAddCustomBanner: 'Kein Zugang zum Hinzufügen von <br> Benutzerdefiniertem Banner',
    createdBy: 'Erstellt von',
    welcomeToFunkiblog: 'Willkommen bei <br> FunKIBlog',
    pleaseWatchTheVideo: 'Bitte sieh dir dieses Video an, <br> bevor du FunKIBlog nutzen kannst',
    videoAvailable: 'Das Video wird angezeigt, <br> bis der Timer bei 0 steht.',
    promoAccess: 'Nur innerhalb von 72 Stunden hast du die Möglichkeit auf ein Rabattangebot für den PRO-Tarif',
    minTime: 'Minuten',
    secTime: 'Sekunden',
    discountOffer: 'Nur innerhalb von 72 Stunden hast du Zugang <br> zu einem Rabattangebot für den PRO-Tarif',
    hoursPlural: '{n} Stunden | {n} Stunden | {n} Stunden',
    minutesPlural: '{n} Minuten | {n} Minuten | {n} Minuten',
    secondsPlural: '{n} Sekunden | {n} Sekunden | {n} Sekunden',
    notAvailable: 'Nicht verfügbar',
    keywordSearchRequests: 'keyword search requests | keyword search request | keyword search requests',
    recalculationLimits: 'Die Neuberechnung des SEO-Scores ist nicht verfügbar, da das Limit erreicht wurde. Erweitern Sie Ihren Plan, um alle Funktionen zu nutzen.',
    optimizingLeft: 'SEO-Optimierung Limit in:',
    thereAreDaysLeft: 'Es sind noch {n} Tage bis zum Ende der kostenlosen Berechnung des SEO-Scores übrig',
    featureIsNoLongerAvailable: 'Diese Funktion ist für Ihren aktuellen Tarif nicht mehr verfügbar.',
    youCanNoLongerRecalculate: 'Sie können den SEO Score <br> nicht mehr neu berechnen',
    thereWereNoitemsFound: 'There were no items found',
    postAuthor: 'Beitrag Autor',
    listOfAuthors: 'Die Liste der Autoren, die am Ende des Artikels angezeigt werden soll.',
    editAuthors: 'Autor bearbeiten',
    authors: '{n} autoren | {n} autor | {n} autoren',
    authorAdded: 'Autor erfolgreich hinzugefügt',
    metaAuthorTagDescription: 'Der Meta Autor Tag gibt den Autor des Inhalts an, was für Suchmaschinen wichtig ist, um Ihren Online-Ruf, Ihre Glaubwürdigkeit und das Vertrauen des Publikums zu verbessern.',
    welcomeTo: 'Willkommen bei',
    fun: 'Fun',
    tools: 'Tools',
    powerfulToolsDescription: 'Leistungsstarke Tools basierend auf künstlicher Intelligenz.',
    createContentEasily: 'Erstellen Sie Inhalte einfach mit FunKI Tools!',
    blogServiceDescription: 'Erstellen Sie einzigartige Inhalte, verwalten und optimieren Sie Ihre Blogs mit künstlicher Intelligenz.',
    socialServiceDescription: 'Erstellen Sie mithilfe künstlicher Intelligenz Beiträge in beliebten sozialen Netzwerken und veröffentlichen Sie sie jederzeit.',
    profileDescription: 'Möchten Sie Ihre E-Mail-Adresse, Ihr Passwort oder die Sprache ändern? Hier entlang für Sie!',
    goTo: 'Zum',
    profile: 'Profil',
    noAccess: 'Kein Zugang',
    didNotFindFunctionality: 'Sie haben die gewünschte Funktion nicht gefunden?',
    writeToSupport: 'Schreiben zur support',
    channelsDescription: 'Hier ist Ihre Liste mit verbundenen Kanälen.',
    connectYourChannels: 'Verbinden Sie Ihre Kanäle',
    unlockYourSocialMedia: 'Entfessele deinen Erfolg in den sozialen Medien mit einem FunKISocial! Er ist dein ultimatives Werkzeug für mühelose Terminplanung und Organisation von Inhalten auf Plattformen wie Facebook, Instagram und Twitter. Sag Tschüss zum Chaos und hallo zu einer strategischen, konsistenten Online-Präsenz. Steigere deine Marke, begeistere deine Zielgruppe und erfülle deine Marketingziele ganz einfach!',
    allChannels: 'Alle Kanäle',
    forSmallBusinesses: ' Für kleine Unternehmen',
    forCreators: 'Für Kreative',
    forCommerce: 'Für den E-Commerce',
    waitWhyDoI: 'Warte... warum muss ich mich mit Facebook authentifizieren?',
    inOrderForFunkisocial: 'Damit FunKISocial in deinem Namen auf den ausgewählten Facebook-Seiten posten kann, <span class="text-black">musst du die Berechtigungen für alle Seiten akzeptieren</span> (auch für diejenigen, die nicht mit FunKISocial verbunden werden sollen).',
    isItSafe: 'Ist das sicher?',
    readMoreAboutHowToCreate: '<a href="https://www.facebook.com/help/104002523024878" target="__blank" class="text-primary">Erfahre mehr, wie du eine Seite erstellst.</a>',
    toConnectFacebookPage: 'Um eine Facebook-Seite mit deinem FunKISocial-Account zu verbinden, <span class="text-black">musst du dich mit einem persönlichen Profil authentifizieren, das Admin-Rechte für diese Facebook-Seite hat.</span>',
    restAssuredWeSecurely: 'Sei versichert, dass wir deine Daten und deinen Zugang zu sozialen Netzwerken sicher und geschützt speichern. Außerdem speichern wir nur einen temporären Token, den du jederzeit in den <a href="https://www.facebook.com/settings?tab=business_tools" target="__blank" class="text-primary">Facebook Business Verbindungen</a> oder in FunKISocial durch einen Klick auf „Trennen“ neben dem Facebook-Kanal widerrufen kannst.',
    somethingWentWrong: 'Ups, etwas ist schief gelaufen',
    tryAgainLater: 'Bitte versuchen <br> Sie es später noch einmal',
    selectFacebookAccount: 'Facebook Konto wählen',
    selectLinkedinAccount: 'LinkedIn Konto wählen',
    checkOutOurGuide: 'Check out our guide to supported account types for more details.',
    facebookPage: 'Facebook Seite',
    facebookPageDescription: 'Eine öffentliche Seite, die andere Nutzer liken können',
    facebookGroup: 'Facebook Gruppe',
    facebookGroupDescription: 'Eine Gruppe, in der Nutzer beitreten können.',
    facebookGroupNotSupported: 'Die direkte Veröffentlichung in Facebook-Gruppen wird von Meta nicht mehr unterstützt.',
    wellDoneYouAddedChannel: 'Gratuliere! <br> Du hast deinen Kanal verbunden',
    youSuccessfullyConnected: 'Sie haben einen Kanal erfolgreich verbunden. Jetzt können Sie mit der Planung von Beiträgen beginnen.',
    whichChannelsToAdd: 'Welchen Kanal möchtest du hinzufügen?',
    cantConnectInstagram: 'Falls du deinen Instagram Kanal nicht verbinden kannst, findest du <a href="https://www.facebook.com/business/help/connect-instgram-to-page" target="_blank" class="text-green-3">hier</a> mögliche Gründe!',
    weCouldntFindAccounts: 'Wir konnten keine Instagram-Konten finden, die mit diesem Konto verbunden sind.',
    makeSureYouAreSigningIn: 'Vergewissere dich, dass du dich mit dem Facebook-Konto anmeldest, das über Administratorrechte für das Konto verfügt, das du verbinden möchtest.',
    readMoreAboutHowToSetup: 'Lesen Sie mehr darüber, wie man ein <a href="https://help.instagram.com/502981923235522" target="_blank" class="text-green-3">Business-konto auf Instagram einrichtet</a> und wie man die <a href="https://www.facebook.com/business/help/connect-instagram-to-page" target="_blank" class="text-green-3">Facebook Business Page mit Instagram Business verbindet</a>',
    weCouldntFindAccountsFacebook: 'Entschuldige, wir konnten keine Facebook-Seite in deinem Konto finden.',
    makeSureYouAreSigningInFacebook: 'Bitte stelle sicher, dass du mit dem persönlichen Facebook-Profil eingeloggt bist, welches Admin-Rechte für die Seite hat, die du verbinden möchtest.',
    readMoreAboutHowToSetupFacebook: '<a href="https://www.facebook.com/help/104002523024878" target="__blank" class="text-primary">Erfahre mehr, wie du eine Seite erstellst.</a>',
    linkedinPage: 'LinkedIn Seite',
    linkedinPageDescription: 'Eine öffentliche Seite',
    linkedinProfile: 'LinkedIn Profil',
    linkedinProfileDescription: 'Eine öffentliche Profil',
    goToLinkedin: 'Zu LinkedIn gehen',
    beforeYouStart: 'Bevor Sie anfangen...',
    linkedinConnectDescription: 'Wir werden Sie zu LinkedIn weiterleiten, um Ihr Konto mit FunKITools zu verbinden.',
    linkedinConnectDescriptionBot: 'Wenn Sie bereits bei LinkedIn angemeldet sind, überprüfen Sie, ob Sie das richtige Konto verbinden.',
    welcomeToFunkisocial: 'Willkommen bei FunKISocial',
    connectYourFirstChannel: 'Um loszulegen, müssen Sie Ihren ersten Kanal verbinden',
    generateTextWithAi: 'Generieren Sie Text mit KI',
    left: 'übrig',
    socialNetwork: 'Social Network',
    posts: 'Beiträge',
    postsN: '{n} Beiträge | {n} Beitrag | {n} Beiträge',
    noPosts: 'Keine Beiträge',
    addNewPost: 'Neuen Beitrag hinzufügen',
    january: 'Januar',
    february: 'Februar',
    march: 'Marsch',
    april: 'April',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Dezember',
    previewWillBeAvailable: 'Vorschauen werden beim Anpassen von Beiträgen verfügbar sein',
    theDayIsOver: 'Der Tag ist vorbei',
    deletePost: 'Sind Sie sicher, dass Sie diesen Beitrag löschen wollen?',
    youAreGoingToDelete: 'Sie werden diesen Kanal löschen',
    deleteChannelDescription: 'Es wird nicht mehr möglich sein Beiträge auf diesem Kanal zu veröffentlichen, alle bestehenden Beiträge und Daten werden unwiderruflich gelöscht.<br><br>Diese Aktion kann nicht rückgängig gemacht werden.Probleme mit der Verbindung? Nutze die Option die Verbindung zu aktualisieren.',
    advanceSettingsDesc: 'Erweiterte Einstellungen für die Suche nach Erwähnungen auf der Grundlage der für Ihre Brand ausgewählten Keywords.',
    funKIReplyDesc: 'Ihr ultimativer AI Social Post Finder & Replier. FunKIReply hilft Ihnen, die richtigen Posts zu finden und effizient markenspezifische KI-Antworten zu erstellen.',
    funKIBooksDesc: 'Erstellen Sie mit ein paar Klicks erstaunliche, auf künstlicher Intelligenz basierende PDF.',
    funKITubeDesc: 'Create amazing videos based on artificial intelligence in a couple of clicks.',
    teamMembersSubtitle: 'Team-Funktion, mit der Sie Ihr Team zu Ihrem Konto einladen können. So können Sie gemeinsam an Projekten arbeiten und nahtlos an der Verwirklichung Ihrer kreativen Ziele arbeiten.',
    youDontHaveMembers: 'Bisher haben Sie noch keine Mitglieder in Ihrem Team',
    provideDetailsOfMember: 'Geben Sie Einzelheiten über das potenzielle Mitglied an',
    selectTheServices: 'Select the service access that the member will have',
    allServicesThatAreAvailable: 'Alle Dienste, die Ihnen zur Verfügung stehen, sind automatisch auch für das Mitglied verfügbar. Wenn Sie Zugang zu einem weiteren Dienst erhalten, wird dieser automatisch auch für das Mitglied verfügbar.',
    invitationSent: 'Einladung verschickt',
    weHaveAlreadySentAnEmail: 'Wir haben bereits eine E-Mail mit einem Bestätigungslink an die Mailbox des Mitglieds geschickt. Sobald er den Beitritt zu Ihrem Team bestätigt, werden Sie benachrichtigt.',
    emailPlaceholder: 'z.B. member-email{\'@\'}domain.com',
    aspectRatio: 'Seitenverhältnis',
    square: 'Quadrat (1:1)',
    portrait: 'Porträt (9:16)',
    widescreen: 'Widescreen (16:9)',
    squareDescription: 'Quadratisch - Empfohlen für Facebook, Instagram und X',
    portraitDescription: 'Hochformat - Empfohlen für Pinterest und TikTok',
    widescreenDescription: 'Widescreen - Empfohlen für LinkedIn',
    loseChanges: 'Sie werden alle Änderungen verlieren, dies kann nicht rückgängig gemacht werden.',
    paymentProvidersDescription: 'Hier können Sie einen Zahlungsanbieter hinzufügen, damit Sie Geld für Ihre PDF erhalten können. Nachdem Sie den Zahlungsanbieter hier hinzugefügt haben, können Sie ihn in den PDF Einstellungen mit Ihrem PDF verknüpfen.',
    noConnectedProvider: 'Du hast noch keine <br> Zahlungsanbieter verbunden',
    landingPreview: 'Vorschau Landingpage',
    thankyouPagePreview: 'Vorschau Dankeseite',
    uploadYourOwnMedia: 'Lade deine eigenes Media hoch',
    videoEmbedUrl: 'Video einbetten URL',
    videoEmbedUrlPlaceholder: 'z.B. https://www.youtube.com/embed/qwe123qwe ODER https://player.vimeo.com/video/1234567890',
    recommendedSize: 'Empfohlene Größe {0}',
    unlockYourBookNow: 'Unlock your book now',
    getItNowForFree: 'Get it now for free',
    booksDomainSubtitle: 'Mach deine PDF Seiten wahrlich einzigartig und passe Einstellungen nach deinen Belieben an. Du kannst Tracking Codes anpassen, eine benutzerdefinierte Domain nutzen und das Design deiner PDF Download Seiten individualisieren. Starte am besten sofort!',
    noBooksDomainsSubtitle: 'Verbinde deinen FunKI PDF Zugang mit einer Domain. Anschließend wird sie in der Übersicht angezeigt.',
    chapterWithAi: 'Kapitel mit AI',
    blankChapter: 'Leeres Kapitel',
    youDontHaveChapters: 'Sie haben noch keine Kapitel.',
    createYourFirstChapter: 'Erstellen Sie Ihr erstes Kapitel',
    beforeYouStartGeneratingChapter: 'Bevor Sie mit der Erstellung eines Kapitels beginnen, füllen Sie Ihre PDF-Informationen aus, um mehr relevante Inhalte zu erhalten. Gehen Sie bewusst vor, denn das Ergebnis hängt direkt davon ab.',
    pageDoesntExist: 'Leider gibt es eine solche Seite nicht.',
    weCouldntFindPage: 'Wir konnten eine solche Seite nicht finden, oder die Seite wurde entfernt.',
    contentShouldNotBeEmpty: 'Der Inhalt sollte nicht leer sein',
    youCantDeleteLastChapter: 'Sie können kein einziges Kapitel löschen',
    youDontHavePosts: 'You don\'t have any scheduled posts yet.',
  },
  label: {
    assistantPlaceholder: 'Unser KI-Assistent <br>hilft Ihnen bei allen <br>Fragen weiter',
    iamAlreadyWriting: 'Ich schreibe schon...',
    assistantWrites: 'Assistent schreibt...',
    aiInputPlaceholder: 'Deine Nachricht (Zum Beispiel: "Ich brauche einen Verkaufstext für meine Webseite zum Thema Online Coaching")',
    improve: 'Verbessern',
    short: 'Kürzen',
    punchier: 'Verstärken',
    use: 'Nutzen',
    insert: 'Einfügen',
    selectedText: 'Ausgewählter Text',
    customAction: 'Benutzerdefinierte Aktion',
    whatDoYouWantToDo: 'Was möchtest du machen?',
    aiAssistant: 'AI Assistant',
    regenerateTitle: 'Achtung! Die Inhalte <br> der Seite werden neu erstellt<br> und alte Inhalte überschrieben.',
    regenerateDesc: 'Alle bisherigen Änderungen <br>werden bei einer Neu-Generierung unwiderruflich <br>verloren gehen',
    errorGeneration: 'Ein Fehler ist aufgetreten',
    errorGenerationDesc: 'Du kannst den Prozess neu starten oder die Seite manuell anpassen',
    pageCreatedSuccessfully: 'Die Seite wurde erfolgreich erstellt',
    pageCreatedSuccessfullyDesc: 'Du kannst sie nun anpassen',
    weStartedCreatingContent: 'Wir haben mit der Erstellung der Inhalte für deine Seite gestartet',
    weStartedCreatingContentDesc: 'Bitte warte einen Augenblick, du kannst danach die Seite anpassen',
    takeBook: 'Nimm das Buch',
    globalTrackingCodes: 'Globale Tracking Codes',
    landingNotCreated: 'Noch keine Landingpage erstellt',
    thankyouNotCreated: 'Noch keine Dankeseite erstellt',
    back: 'Back',
    publicURL: 'Öffentliche URL',
    addItem: 'Element hinzufügen',
    promoText: 'Promo text',
    paid: 'Paid',
    gift: 'Gift',
    rating: 'Bewertung',
    seoSettings: 'SEO settings',
    createLandingPage: 'Verkaufsseite erstellen',
    createThankYouPage: 'Dankeseite erstellen',
    footer: 'Footer',
    links: 'Links',
    footerLogoImage: 'Footer logo image',
    additionalNotice: 'Additional notice',
    callToAction: 'Call to action',
    brandedContentVisibility: 'Die Sichtbarkeit von Markeninhalten kann nicht auf privat gesetzt werden',
    disableComments: 'Kommentare sind aufgrund der Datenschutzeinstellungen deines Kontos nicht verfügbar.',
    disableDuetAndStitch: 'Da Ihr Konto privat ist, können andere Ihre Inhalte nicht wiederverwenden.',
    duet_and_stitch: 'Duett und Stitch sind bei Videos von privaten Konten nicht verfügbar',
    bookGenerator: 'PDF-Generator',
    about: 'Über',
    structure: 'Struktur',
    oldPassword: 'Altes Passwort',
    confirmPassword: 'Passwort bestätigen',
    readNow: 'Jetzt lesen',
    chapters: 'Kapitel',
    borderSize: 'Rahmengröße',
    padding: 'Abstand',
    backgroundColor: 'Hintergrundfarbe',
    borderColor: 'Rahmenfarbe',
    borderRadius: 'Rahmenradius',
    italics: 'Kursivschrift',
    fontColor: 'Schriftfarbe',
    fontSize: 'Schriftgröße',
    fontStyleItalic: 'Schriftstil kursiv',
    fontFamily: 'Schriftart',
    bookTitle: 'PDF Titel',
    advancedSettings: 'Erweiterte Einstellungen',
    customizeTemplateColor: 'Vorlagenfarbe ändern',
    generate: 'Generieren',
    cover: 'Abdeckung',
    bookCoverGenerationModel: 'Art der PDFcover-Generierung',
    autoresponderName: 'Name des Autoresponders',
    googleSpreadSheetUrl: 'Google SpreadSheet URL',
    apiKeyProvider: 'API Schlüssel',
    enableDoi: 'Enable DOI',
    addHeaders: 'Header hinzufügen',
    headerTrackingCode: 'Header Tracking Code',
    footerTrackingCode: 'Footer Tracking Code',
    buttonColor: 'Button Farbe',
    buttonIconColor: 'Button Icon Farbe',
    lockScreenButtonText: 'Text der Schaltfläche „Bildschirm sperren“.',
    lockScreenButtonIcon: 'Symbol für die Schaltfläche „Bildschirm sperren“.',
    lockScreen: 'Bildschirmsperre',
    currency: 'Währung',
    price: 'Preis',
    products: 'Produkte',
    addAutoresponders: 'Autoresponders hinzufügen',
    paywall: 'Paywall',
    favicon: 'Favicon',
    publishBook: 'PDF veröffentlichen',
    metaTitle: 'Meta Titel',
    seo: 'SEO',
    trackingCode: 'Tracking Code',
    design: 'Design',
    access: 'Zugang',
    icon: 'Icon',
    background: 'Hintergrund',
    passwordProtected: 'Schutz durch Passwort',
    required: 'Erforderlich',
    bookName: 'PDF Name',
    crop: 'Zuschneiden',
    nextGeneration: 'Nächste Generation',
    reachedLimit: 'Sie haben das Limit erreicht.  Insgesamt stehen Ihnen {limit} Keywords zur Verfügung.',
    limitTooltip: 'Dieses Keyword wurde über das Limit hinaus hinzugefügt. Sie können danach eine Suche nach diesem Stichwort starten: {date}',
    instantSearchAvailableLater: 'Die Suche nach Erwähnungen aufgrund bestimmter Keywords wird später verfügbar sein.',
    instantSearchAvailableLaterDesc: 'Du hast bereits dein Keyword-Limit erreicht. Du kannst nach Erwähnungen neu hinzugefügter Keywords <b>{newKeywords}</b> suchen. Diese müssen hinter dem Datum liegen, welches auf der Keyword-Seite für das jeweilige Keyword festgelegt ist. Anschließend werden nur noch die folgenden Keywords gesucht: <b>{oldKeywords}</b>.',
    searchAvailableLater: 'Die Suche nach Erwähnungen wird später verfügbar sein.',
    searchAvailableLaterDesc: 'Du hast das Limit der Anzahl an Keywords erreicht. Du kannst nach Erwähnungen neu hinzugefügter Keywords suchen, die hinter dem {date} liegen.',
    availableSearching: 'Verfügbar für die Suche ab',
    saveAsDraft: 'Der Beitrag wird als Entwurf gespeichert',
    invalidTikTokMedia: 'Ihr Video sollte nicht länger als {duration} Sekunden sein.',
    paidPartnership: 'Paid partnership',
    promotionalContent: 'Promotional content',
    aiGenerated: 'Creator labeled as AI-generated',
    isAvailableTikTokCreatePostByPostContent: 'Sie müssen angeben, ob Ihr Inhalt Sie selbst, einen Dritten oder beides fördert.',
    disclosePostContent: 'Inhalt des Beitrags offenlegen',
    disclosePostContentDesc: 'Lassen Sie andere wissen, dass dieser Beitrag eine Marke, ein Produkt oder eine Dienstleistung bewirbt.',
    allowUsersTo: 'Erlauben Sie Nutzern',
    brandedContentMsg: 'Durch das Posten stimmst du der <a class="text-primary" target="_blank" href="https://www.tiktok.com/legal/page/global/bc-policy/en">Richtlinie für markenbezogene Inhalte</a> und der <a class="text-primary" target="_blank" href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en">Musiknutzungsbestätigung</a> von TikTok zu.',
    yourBrandMsg: 'Durch das Posten stimmst du der <a class="text-primary" target="_blank" href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en">Musiknutzungsbestätigung</a> von TikTok zu.',
    aiGeneratedContent: 'KI-generierte Inhalte',
    aiGeneratedContentDesc: 'Fügen Sie dieses Etikett für aigc hinzu. <a class="text-primary" href="https://www.tiktok.com/tns-inapp/pages/ai-generated-content" target="_blank">Learn more</a>',
    brandedContent: 'Markenbezogene Inhalte',
    brandedContentDesc: 'Ihr Foto/Video wird als \'Bezahlte Partnerschaft\' gekennzeichnet',
    brandedContentDescDisable: 'Um Ihren Beitrag als gebrandeten Inhalt zu veröffentlichen, muss Ihr Beitrag auf „Öffentlich“ eingestellt sein.',
    brandedContentDescActive: 'Sie befinden sich in einer bezahlten Partnerschaft mit einer Marke. Nachdem Sie das Video veröffentlicht haben, öffnen Sie Ihre TikTok-App und verknüpfen Sie die Kampagne unter den „Anzeigeneinstellungen“ des Videos.',
    yourBrand: 'Deine Marke',
    yourBrandDesc: 'Ihr Foto/Video wird als \'Werbeinhalt\' gekennzeichnet',
    yourBrandDescActive: 'Sie werben für sich selbst oder Ihr eigenes Unternehmen.',
    selectPrivacy: 'Privatsphäre auswählen',
    whoCanSee: 'Wer kann diesen Beitrag sehen',
    skip: 'Überspringen',
    generateReply: 'Antwort generieren',
    viewPost: 'Beitrag anzeigen',
    fetchPeriod: 'Zeitraum abrufen',
    new: 'Neu',
    pleaseWait: 'Bitte warten Sie 1-2 Minuten',
    pleaseWaitDesc: 'Wir arbeiten daran, Ihnen neue Beiträge auf der Grundlage Ihrer Schlüsselwörter zu liefern',
    allKeywords: 'Alle Keywords',
    saveChanges: '',
    markAsReplied: 'Als geantwortet markieren',
    unmark: 'Unmarkieren',
    everyDay: 'Jeden Tag',
    everyWeek: 'Jede Woche',
    everyMonth: 'Jeden Monat',
    everyYear: 'Jährlich',
    advanceSettings: 'Erweiterte Einstellung',
    chooseCountry: 'Land wählen',
    chooseLanguage: 'Sprache wählen',
    whenFetchPosts: 'Wann werden Beiträge abgerufen',
    instantFetch: 'Sofortiges Abrufen',
    showMore: 'Zeig mehr',
    searchImages: 'Suche nach Bildern...',
    imageSearch: 'Bildersuche',
    typeImageDescription: 'Schreiben Sie eine Beschreibung des Bildes oder Schlüsselwörter, um die Bilder zu finden',
    searching: 'Suchen...',
    editSmtp: 'SMTP ändern',
    deleteSmtp: 'SMTP löschen',
    allPosts: 'Alle Beiträge',
    allChannels: 'Alle Kanäle',
    channels: 'Kanäle',
    addPostAuthor: 'Add post author',
    authors: 'Autoren',
    addAuthor: 'Autor erstellen',
    editAuthor: 'Autor bearbeiten',
    authorName: 'Autor name',
    authorDescription: 'Autor Beschreibung',
    newMailSeries: 'Neue Emailserie',
    newMail: 'Neue E-Mail',
    add: 'Hinzufügen',
    editDomain: 'Domain bearbeiten',
    deleteDomain: 'Domain löschen',
    exportSuccess: 'Datei erstellt',
    takeSomeTime: 'Das kann ein bisschen dauern. Bitte warten',
    download: 'Download',
    exportContacts: 'Kontakt exportieren',
    dontHave: 'Du hast noch keine Kontakte',
    dontHaveLead: 'Fülle deinen Blog mit Beiträgen und aktiviere die Newsletter Funktion in den Blog Einstellungen, um Kontakte zu sammeln.',
    dontHaveLeadBooks: 'Du erhältst hier eine Übersicht aller Kontakte, die sich eines deiner PDF’s gesichert haben.',
    delete: 'Löschen',
    deleteLead: 'Kontakt löschen',
    status: 'Status',
    confirmed: 'Bestätigt',
    pending: 'Ausstehend',
    rejected: 'Abgelehnt',
    leadCreatedAt: 'Kontakt erstellen',
    leadSubscribePage: 'Quelle',
    email: 'E-mail',
    export: 'Export',
    active: 'Aktiv',
    inactive: 'Inactiv',
    smtpUser: 'SMTP Nutzer',
    smtpPassword: 'SMTP Passwort',
    port: 'Port',
    none: 'None',
    ssl: 'SSL',
    tls: 'tls',
    smtpServer: 'SMTP Server',
    fromName: 'Von: Name',
    fromEmail: 'Von: Email',
    yes: 'Ja',
    no: 'Nein',
    secure: 'Sicher',
    smtpAuth: 'SMTP Bestätigung',
    addSmtp: 'SMTP hinzufügen',
    addBrandVoice: 'Markenstimme hinzufügen',
    internalPage: 'Internal page',
    magic: 'Magic',
    rewrite: 'Umschreiben',
    expand: 'Erweitern',
    correct: 'Korrigiere',
    optimize: 'Verbessere',
    liveTrainings: 'Live trainings',
    apply: 'Anwenden',
    rememberMe: 'Eingeloggt bleiben',
    country: 'Land',
    language: 'Sprache',
    courses: 'Kurse',
    ok_thanks: 'Ok, Danke!',
    targetKeywords: 'Zielkeyword',
    currentCountry: 'Land: {country}',
    currentLanguage: 'Sprache: {language}',
    home: 'Start',
    author: 'Autor',
    limits: 'Deine Limits',
    share: 'Teilen',
    seeAlso: 'Sieh auch',
    support: 'Support',
    allArticles: 'Alle Artikel',
    reachToAverage: '{0}% vom Durchschnitt der Wettbewerber erreicht',
    defaultDomain: 'Standard Domain',
    colorTemplate: 'Template Farbe',
    logo: 'Logo',
    customBanner: 'Benutzerdefinierter Banner',
    link: 'Link',
    bannerUrl: 'Banner URL',
    headerLink: 'Header Link',
    footerLink: 'Footer Link',
    articlePublish: 'Artikel veröffentlichen',
    slug: 'Slug',
    titleH1: 'Titel H1',
    briefComment: 'Kurzer Kommentar',
    addMultimedia: 'Multimedia hinzufügen (optional)',
    photo: 'Foto',
    aiImage: 'KI Bild',
    domain: 'Domain',
    connectDomain: 'Domain verbinden',
    pageTitle: 'Seitentitel',
    pageUrl: 'Seiten-URL',
    keyword: 'Keyword',
    keywords: 'Keywords',
    you: 'Du',
    target: 'Ziel',
    metaAuthor: 'Meta Autor',
    metaAltText: 'Meta Alt text',
    bold: 'Schriftart',
    italic: 'Kursiv',
    underline: 'Unterstrichen',
    strikethrough: 'Durchgestrichen',
    numberedList: 'Nummerierte Liste',
    bulletedList: 'Aufzählung',
    alignLeft: 'Linksbündig',
    alignCenter: 'Zentriert',
    alignRight: 'Rechtsbündig',
    volume: 'Volumen',
    difficulty: 'Schwierigkeit',
    veryEasy: 'Sehr leicht',
    easy: 'Leicht',
    possible: 'Möglich',
    difficult: 'Kompliziert',
    hard: 'Schwierig',
    veryHard: 'Sehr schwierig',
    logout: 'Logout',
    generation: 'Generation',
    title: 'Titel',
    metaDescription: 'Meta Beschreibung',
    metaKeywords: 'Meta Keywords',
    imageAnalysis: 'Bilderanalyse',
    contentLength: 'Contentlänge',
    search: 'Suche',
    firstName: 'Vorname',
    lastName: 'Nachname',
    subdomain: 'Subdomain',
    subdomainName: 'Subdomain Name',
    preference: 'Präferenz',
    systemLanguage: 'System Sprache',
    emptyBlogPage: 'Leere Blogseite',
    addKeyword: 'Keyword hinzufügen',
    addNegativeKeyword: 'Negatives Keyword hinzufügen',
    negativeKeywords: 'Negatives Keyword',
    deleteKeyword: 'Keyword löschen',
    addPositiveKeyword: 'Positives Keyword hinzufügen',
    templateLayout: 'Template layout',
    url: 'URL',
    notification: 'Notification',
    addVoice: 'Neue Stimme',
    myVoice: 'Meine Markenstimme',
    brandVoice: 'Markenstimme',
    enterBrandedText: 'Gib deinen Markentext ein',
    nameThisVoice: 'Benennen Sie diese Stimme',
    makeThisVoiceDefault: 'Legen Sie diese Stimme als Standard fest',
    editVoice: 'Stimme ändern',
    deleteVoice: 'Stimme löschen',
    newsletter: 'Newsletter',
    emailChains: 'Emailserie',
    autoresponders: 'Autoresponders',
    addEmailChain: 'Neue Emailserie',
    emailChainName: 'Emailserie Name',
    name: 'Name',
    smtp: 'SMTP',
    defaultSmtp: 'Default SMTP',
    addAutoresponder: 'Neuer Autoresponder',
    myAutoresponder: 'Mein Autoresponder',
    editAutoresponder: 'Autoresponder ändern',
    autoresponderSettings: 'Autoresponder-Einstellungen',
    deleteAutoresponder: 'Delete autoresponder',
    type: 'Type',
    apiUrl: 'API URL',
    apiKey: 'API Key',
    googleSpreadsheetUrl: 'Google SpreadSheet URL',
    login: 'Log in',
    selectType: 'Select type',
    selectPage: 'Select page',
    textButton: 'Text Button',
    privacyPolicyLink: 'Datenschutz Link',
    description: 'Beschreibung',
    myEmailChains: 'Meine Emailserie',
    editEmailChain: 'Emailserie ändern',
    deleteEmailChain: 'Emailserie löschen',
    subject: 'Betreff',
    sendAfter: 'Senden nach',
    emailText: 'E-Mail Text',
    ctaLabel: 'CTA label',
    ctaUrl: 'CTA URL',
    previewEmail: 'Preview email',
    tags: 'Tags',
    mailLists: 'Mail Listen',
    subscription: 'Abonemment',
    range: 'Bereich',
    dayOfCycle: 'Day of cycle',
    campaign: 'Campaign',
    descriptionOfThePicture: 'Beschreibung des Bildes',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    sitemap: 'Sitemap',
    blogName: 'Blog name',
    createEmptyPost: 'Eigenen Beitrag erstellen',
    createPostWithAI: 'Beitrag mit AI erstellen',
    blogSlug: 'Blog slug',
    wordpressPluginKey: 'WordPress Plugin Schlüssel',
    noindex: 'Keine Indexierung',
    metaTags: 'Meta-Tags',
    headMetaTag: 'Header Meta-Tag',
    insertYourMetaTag: 'Meta-Tag einfügen',
    analytics: 'Analytics',
    relatedQuestions: 'Verwandte Fragen',
    optimized: 'Optimized',
    peopleAlsoAsk: 'Ähnliche Fragen',
    aiSuggestedQuestions: 'KI vorgeschlagene Fragen',
    nofollow: 'NoFollow-Link',
    noopener: 'NoOpener-Link',
    noreferrer: 'NoReferrer-Link',
    salesLandingPage: 'Verkaufsseite und Dankeseite',
    landingSectionTitle: 'Verkaufe dein PDF auf einer Verkaufsseite',
    landingSectionDesc: 'Nutze unsere inividuell gestalteten Verkaufs- und Dankeseiten für dein PDF. Passe die Seiten nach deinen Bedürfnissen an. Farben, Logo, Bilder - alles nach deinen Wünschen. Generiere Content mit unserer KI.',
    landingPage: 'Verkaufsseite',
    landingPageDesc: 'Dies ist die Verkaufsseite für dein PDF, die Nutzer vor dem Kauf sehen.',
    thankYouPage: 'Dankeseite',
    thankYouPageDesc: 'Der Nutzer wird nach dem Kauf auf die Dankeseite weitergeleitet. Kopiere den Link zur Dankeseite, um diesen in Digistore24 zu hinterlegen.',
    recent: 'Neueste',
    history: 'Historie',
    today: 'Heute',
    yesterday: 'Gestern',
    backToRecent: 'Zurück zu Neueste',
    upgradePlans: 'Upgrade-Tarife',
    plans: 'Plans',
    free: 'Free',
    pro: 'Pro',
    cloud: 'Cloud',
    yearly: 'jährlich',
    popular: 'Popular',
    category: 'Kategorie',
    manage: 'Verwalten',
    categoryName: 'Kategorie rName',
    manageCategory: 'Kategorie verwalten',
    addCategory: 'Kategorie hinzufügen',
    uncategorized: 'Uncategorized',
    planAccess: 'Wähle deinen Tarif',
    welcome: 'Willkommen',
    left: 'Übrig',
    articles: 'Artikel',
    ideas: 'Ideen',
    competitors: 'Wettbewerber',
    service: 'Service',
    createPost: 'Beitrag erstellen',
    refreshConnection: 'Verbindung erneuern',
    disconnectChannel: 'Disconnect channel',
    authenticate: 'Authentifizieren',
    authenticateWithFacebook: 'Mit Facebook authentisieren',
    results: 'Ergebnisse',
    toneOfVoice: 'Tonalität',
    text: 'Text',
    channel: 'Kanal',
    replied: 'Geantwortet',
    mentions: 'Erwähnungen',
    showNewOnly: 'Nur Neues anzeigen',
    showSkippedOnly: 'Nur Überspringen anzeigen',
    generationReply: 'Antwort generieren...',
    inviteTeamMember: 'Team-Mitglied einladen',
    editTeamMember: 'Edit Team member',
    myTeam: 'Mein team',
    invite: 'Einladen',
    fullAccess: 'Voller Zugang',
    someServices: 'Partieller Zugang',
    allowFullAccess: 'Vollständigen Zugang gewähren',
    gotIt: 'Verstanden',
    week: 'Woche',
    month: 'Monat',
    visibility: 'Visibility',
    license: 'License',
    createBook: 'PDF erstellen',
    addChapter: 'Kapitel hinzufügen',
    desktop: 'Desktop',
    mobile: 'Mobile',
    tablet: 'Tablet',
    contacts: 'Kontakt',
    addNewAbove: 'Oben neu hinzufügen',
    addNewBelow: 'Unten neu hinzufügen',
    linkSharing: 'Link teilen',
    publicLink: 'Öffentlicher Link',
    microsoftWord: 'Microsoft Word',
    pdf: 'PDF',
    html: 'HTML',
    addYourNote: 'Fügen Sie Ihre Notiz hinzu',
    addNote: 'Notiz hinzufügen',
    endChapter: 'Kapitel beenden',
    createNewChapter: 'Neues Kapitel erstellen',
    setting: 'Einstellungen',
    content: 'Inhalt',
    note: 'Notiz',
    createContact: 'Kontakt erstellen',
    contactName: 'Kontaktname',
    mail: 'Mail',
    myProvider: 'Mein Zahlungsanbieter',
    providers: 'Zahlungsanbieter',
    editProvider: 'Zahlungsanbieter ändern',
    deleteProvider: 'Zahlungsanbieter löschen',
    selectStatus: 'Status wählen',
    colorSettings: 'Farbeinstellungen',
    offer: 'Angebot',
    timerDuration: 'Timer Duration',
    buttonText: 'Button text',
    headLogoImage: 'Head logo image',
    header: 'Header',
    promo: 'Promo',
    subtitle: 'Untertitel',
    media: 'Media',
    video: 'Video',
    imageLeft: 'Bild Links',
    imageRight: 'Bild Rechts',
    items: 'Elemente',
    overview: 'Übersicht',
    createItem: 'Create item',
    editItem: 'Edit item',
    featuresGrid: 'Features Raster',
    laptopImage: 'Laptop Bild',
    phoneImage: 'Telefon Bild',
    featuresList: 'Features Liste',
    carousel: 'Bilderkarusell',
    headlines: 'Headlines',
    headlinesWithButton: 'Headlines with button',
    buttonUrl: 'Button URL',
    aiGeneratedPDF: 'AI generiert PDF',
    blankPDF: 'Leeres PDF',
    createNewPDF: 'Neuen PDF erstellen',
    chapterTitle: 'Kapitel titel',
    pdfDetails: 'PDF-Einstellungen',
    colors: 'Farben',
    fontSettings: 'Schriftart-Einstellungen',
    h2FontSize: 'Title H2 font size',
    h3FontSize: 'Title H3 font size',
    h4FontSize: 'Title H4 font size',
    pFontSize: 'Paragraph font size',
    noteFontSize: 'Note font size',
    publishNow: 'Publish now',
    moveToDraft: 'Move to draft',
    duplicate: 'Duplicate',
    discover: 'Discover',
  },
  button: {
    retry: 'Wiederholung',
    replace: 'Ersetzen',
    remove: 'Entfernen',
    addNewProviders: 'Fügen Sie neue Anbieter hinzu',
    selectPayment: 'Zahlungsanbieter auswählen',
    newPayment: 'Zahlungsanbieter hinzufügen',
    moveToCategory: 'Zur Kategorie verschieben',
    saveSetting: 'Einstellung sichern',
    downloadBook: 'PDF herunterladen',
    bookSettings: 'PDF Einstellungen',
    no: 'Nein',
    apply: 'Anwenden',
    next: 'Nächstes',
    saveAutoresponder: 'Autoresponder speichern',
    addFirstEmail: 'Erste Email hinzufügen',
    newEmail: 'Neue Email',
    selectMailChains: 'Wählen Sie Postketten aus',
    newMailChains: 'Neue Emailserie',
    addAutoresponder: 'Autoresponder hinzufügen',
    addNewAutoresponder: 'Neuen Autoresponder hinzufügen',
    changeImage: 'Bild ändern',
    loadImage: 'Bild hochladen',
    ok: 'Ok',
    regenerateNow: 'Jetzt regenerieren',
    regenerate: 'Regenerieren',
    runInstantFetch: 'Sofortiges Abrufen',
    saved: 'Gespeicherte',
    saveToCloud: 'In der Cloud speichern',
    original: 'Original',
    wide: 'Breit',
    stories: 'Geschichten',
    portrait: 'Porträt',
    square: 'Quadrat',
    download: 'Download',
    rename: 'Umbenennen',
    saveAsDraft: 'Entwurf speichern',
    shareNow: 'Jetzt teilen',
    editPage: 'Seite bearbeiten',
    change: 'Ändern',
    editPost: 'Beitrag bearbeiten',
    viewPost: 'Beitrag ansehen',
    copyUrl: 'URL kopieren',
    delete: 'Löschen',
    reset: 'Zurücksetzen',
    resetToDefault: 'Zurücksetzen',
    saveSettings: 'Einstellungen speichern',
    addLink: 'Link hinzufügen',
    shareArticle: 'Artikel teilen',
    save: 'Speichern',
    more: 'Mehr',
    upgrade: 'Upgraden',
    update: 'Update',
    cancel: 'Abbrechen',
    reviewSubheadings: 'Zwischenüberschriften überprüfen',
    generate: 'Generieren',
    checkDomainConnection: 'Domainverbindung überprüfen',
    savePage: 'Seite speichern',
    createContent: 'Content erstellen',
    connected: 'Verbunden',
    noConnected: 'Nicht verbunden',
    competitorOverview: 'Überblick der Wettbewerber',
    refreshOutline: 'Gliederung aktualisieren',
    back: 'Zurück',
    preview: 'Vorschau',
    startEditing: 'Bearbeiten starten',
    published: 'Veröffentlicht',
    noPublish: 'Nicht veröffentlicht',
    findKeywords: 'Keywords finden',
    deleteMyAccount: 'Lösche meinen Account',
    deleteLink: 'Link löschen',
    newPost: 'Neuer Beitrag',
    backToPosts: 'Zurück zu Beiträge',
    backToArticles: 'Zurück zu Artikeln',
    close: 'Schließen',
    ended: 'Ended',
    clickHere: 'Click here',
    analyze: 'Analysieren',
    myVoice: 'Meine Markenstimme',
    copy: 'Kopieren',
    edit: 'Bearbeiten',
    select: 'Auswählen',
    insertImage: 'Insert image',
    downloadSitemap: 'Sitemap herunterladen',
    goToEditor: 'Zur Redaktion gehen',
    createBlog: 'Blog erstellen',
    activate: 'Aktivieren',
    deleteBlog: 'Blog löschen',
    startAnalysis: 'Start analysis',
    activateBlog: 'Blog aktivieren',
    readTheGuide: 'Guide ansehen',
    syncPost: 'Synchronisieren',
    syncingFailed: 'Fehlgeschlagen',
    synchronize: 'Synchronisieren',
    downloadPlugin: 'Plugin downloaden',
    insert: 'Einfügen',
    inserted: 'Eingefügt',
    answer: 'Antworten',
    generateMore: 'Mehr generieren',
    clearHistory: 'Historie löschen',
    clear: 'Löschen',
    loadMoreResults: 'Load more results',
    allKeywords: 'Alle Keywords',
    newCategory: 'Neue Kategorie',
    create: 'Erstellen',
    done: 'Fertig',
    getYourDeal: 'Hol dir jetzt dein 72h Angebot',
    addAuthor: 'Autor hinzufügen',
    newChannel: 'Neuer Kanal',
    connect: 'Verbinden',
    refresh: 'Refresh',
    createPost: 'Beitrag erstellen',
    refreshConnection: 'Refresh connection',
    disconnectChannel: 'Disconnect channel',
    backToChannels: 'Zurück zu Kanälen',
    startConnecting: 'Verbindung erstellen',
    addFirstChannel: 'Ersten Kanal hinzufügen',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    saveCrop: 'Save crop',
    addNewThread: 'Add new thread',
    addAndSaveToCloud: 'Zuschneiden und in der Cloud speichern',
    copyText: 'Text kopieren',
    openInNewTab: 'In neuem Tab öffnen',
    copyPublicLink: 'Öffentlichen Link kopieren',
    resetColor: 'Farbe zurückstellen',
    discardChanges: 'Änderungen verwerfen',
    addPaymentProvider: 'Anbieter hinzufügen',
    addItem: 'Element hinzufügen',
    addFirstChapter: 'Erstes Kapitel hinzufügen',
    saveNext: 'Speichern & weiter',
    stopGeneration: 'Stop generation',
  },
  profile: {
    myProfile: 'Mein Profil',
    security: 'Sicherheit',
    email: 'Email Adresse',
    currentEmail: 'Aktuelle Email Adresse',
    changeEmail: 'Email ändern',
    newEmail: 'Neue Email Adresse',
    chooseEmail: 'Neue Email wählen',
    confirmWithPassword: 'Mit Passwort bestätigen',
    hasEmailChangeRequest: 'Anfrage für das Zurücksetzen der Email wurde eingeleitet. Wir haben eine Benachrichtigung mit einem E-Mail-Bestätigungslink gesendet an ',
    password: 'Passwort',
    currentPassword: 'Aktuelles Passwort',
    changePassword: 'Passwort ändern',
    requestForChangeSent: 'Anfrage zum Änder gesendet',
    oldPassword: 'Altes Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    confirmationWasSentPrevious: 'Eine Bestätigungs-E-Mail wurde <br>an Deine vorherige <br>E-Mail gesendet.',
    confirmationWasSent: 'Eine Bestätigungs-E-Mail wurde an Deine<br>E-Mail gesendet.',
    passwordChanged: 'Passwort erfolgreich geändert',
  },
  blog: {
    settingsDesc: 'Mach deinen Blog wahrlich einzigartig und passe Einstellungen nach deinen Belieben an. Du kannst Tracking Codes anpassen, eine benutzerdefinierte Domain nutzen und das Design deines Blogs individualisieren. Starte am besten sofort!',
    dontHavePosts: 'Du hast noch keine <br> Blogbeiträge erstellt',
    dontHavePostsDesc: 'Generiere mit Hilfe der Künstlichen Intelligenz deinen ersten Beitrag',
    newPost: 'Neuer Beitrag',
    noPostFoundMatches: 'Keinen Beitrag gefunden, <br> der dieser Anfrage entspricht',
    settings: 'Blog Einstellungen',
    general: 'Generell',
    title: 'Blog Titel',
    description: 'Blog Beschreibung',
    keywords: 'Blog Keywords',
    language: 'Blog Sprache',
    languageHint: 'Diese Sprache wird standardmäßig für die Erstellung von Blogartikeln verwendet',
    country: 'Blog Land',
    countryHint: 'Dieses Land wird standardmäßig für die Erstellung von Blogartikeln verwendet',
    customDomain: 'Benutzerdefinierte Domain',
    customDesign: 'Benutzerdefiniertes Design',
    customDesignHeader: 'Du kannst das Design des Blogs <br> nach Deinen Wünschen anpassen',
    customDesignDescription: 'Wähle  Markenfarben, ändere Dein Logo<br> und vieles mehr',
    trackingCode: 'Tracking Code',
    headCode: 'Head Code',
    footerCode: 'Footer Code',
    defaultValueHint: 'Es wird der Standardwert aus den Blog-Einstellungen verwendet.',
    allGenerated: 'Alle generierten',
    publish: 'Veröffentlichen',
    noPublish: 'Nicht veröffentlichen',
    deletePost: 'Beitrag löschen',
    noPostsYet: 'Du hast <br> noch keine Blogbeiträge',
    generateYourFirstText: 'Generiere deinen ersten Text. <br> Künstliche Intelligenz wird <br> dir dabei helfen',
    blogUrl: 'Blog URL',
  },
  dashboard: {
    noPosts: 'Keinen Beitrag gefunden, <br> der dieser Anfrage entspricht',
    noKeywordsDesc: 'Finde deine ersten Keywords und erstelle <br> darauf basierend einen Blogbeitrag',
    noBlogPosts: 'Du hast <br> noch keinen Blogbeitrag',
    noKeywords: 'Du hast <br> noch keine Keywords',
    addFirstPost: 'Ersten Beitrag hinzufügen',
    searchKey: 'Schlüssel suchen',
    project: 'Projekt',
    keywords: 'Keywords',
    latest: 'Neueste',
    blogPosts: 'Blogbeiträge',
    blog: 'Blog',
    seoScore: 'SEO Score',
    startFillingBlog: 'Starte damit, deinen Blog zu füllen, und wir werden eine Analyse deines Blogs erstellen.',
  },
  validation: {
    requiredField: '{missingProperty} ist erforderlich',
    required: 'Feld ist erforderlich',
    email: 'Email ist ungültig',
    phone: 'Telefonnummer ist ungültig',
    href: 'Der Link muss gültig sein und mit https:// oder mailto: oder tel beginnen.:',
    url: 'Der Link muss gültig sein und mit http:// oder https:// beginnen.',
    notNumber: 'Wert muss eine Zahl sein',
    invalidPassword: 'Ungültiges Passwort',
    invalidValue: 'Ungültiger Wert',
    minLength: 'Das Feld {field} muss mindestens {min} Zeichen umfassen',
    maxLength: 'Das Feld {field} darf nicht länger als {max} Zeichen sein',
    betweenNumber: 'Das Feld {field} muss zwischen {min} und {max} liegen.',
    subdomain: 'Subdomain darf nur Buchstaben, Zahlen und Bindestrich enthalten',
    passwordIsNotMatched: 'Das Passwort stimmt nicht überein',
    slugAlreadyTaken: 'Slug bereits vergeben',
    bannerLink: 'Bitte fülle das Feld für den Banner-Link aus',
    invalidLink: 'Ungültiger Link',
  },
  domain: {
    getMoreBlog: 'Hole noch mehr aus deinen Blog heraus und erschaffe deine eigene Marke. Verbinde deine eigene Domain mit nur wenigen Schritte damit du noch mehr Leads sammeln kannst.',
  },
  notification: {
    emailSuccessfullyChanged: 'Email erfolgreich geändert',
    successfullySaved: 'Erfolgreich gespeichert!',
    successfullyResetted: 'Erfolgreich zurückgesetzt!',
    successCopy: '{element} kopiert',
    copiedToTheClipboard: 'Der {element} wurde <br/> in die Zwischenablage kopiert',
    linkCopied: 'Link erfolgreich kopiert',
    linkUpdated: 'Link erfolgreich aktualisiert',
    linkDeleted: 'Link erfolgreich gelöscht',
    inputValidUrl: 'Gültige URL eingeben',
    fileIsUploaded: 'Datei hochgeladen',
    passwordChanged: 'Passwort wurde erfolgreich geändert',
    settingsSaved: 'Einstellungen erfolgreich gespeichert',
  },
  error: {
    imageMustHaveSameRatio: 'Die Bilder müssen das gleiche Verhältnis von Breite und Höhe haben. Schneiden Sie Bilder auf das gleiche Verhältnis von Breite und Höhe zu.',
    keywordsLimitReached: 'Sie können nur bis zu {n} Keywords hinzufügen',
    invalidConfirmationCode: 'Ungültiger Bestätigungscode',
    invalidForm: 'Formular ist ungültig!',
    headlineCannotBeWithout: 'Überschrift H2 kann nicht ohne Überschrift H3 sein',
    pleaseSelectService: 'Please select at least 1 service',
    passwordIsNotMatched: 'Passwort stimmt nicht überein',
  },
  colors: {
    fontColor: 'Schrift',
    primaryColor: 'Grundfarbe',
    iconColor: 'Icon',
    borderColor: 'Rahmen',
    cardColor: 'Karte',
    backgroundColor: 'Hintergrund',
    textColor: 'Text',
    titleColor: 'Titel',
    timerColor: 'Timer',
  },
  layoutTitles: {
    blog: 'Blogbeiträge',
    dashboard: 'Dashboard',
    keywords: 'Keywords',
    blogSettings: 'Blog Einstellungen',
    paymentProviders: 'Zahlungsanbieter',
    setting: 'Einstellung',
    domains: 'Domains',
    domain: 'Domain',
    myProfile: 'Mein Profil',
    security: 'Sicherheit',
    liveTrainings: 'Live trainings',
    brandVoice: 'Markenstimme',
    leads: 'Kontakte',
    emailChains: 'Emailserie',
    autoresponder: 'Autoresponder',
    smtp: 'SMTP',
    calendar: 'Kalender',
    channels: 'Kanälen',
    planned: 'Geplant',
    mentions: 'Erwähnungen',
    addBrand: 'Brand hinzufügen',
    replies: 'Antworten',
    settings: 'Einstellungen',
    replied: 'Geantwortet',
    teamMembers: 'Team-Mitglieder',
    myBooks: 'Meine PDF',
    outliers: 'Outliers',
    myVideos: 'My videos',
    myThumbnails: 'My thumbnails',
  },
  seoParameters: {
    hasCoverImage: 'Hat ein Titelbild',
    includesTargetKeyword: 'Beinhaltet Zielkeyword',
    characterCountBetween: 'Zeichenanzahl zwischen {count}',
    keywordsInCloseProximity: 'Keyword in unmittelbarer Nähe',
    targetKeywordInInitialPart: 'Zielkeyword in Einleitung',
    uniquinessVsCompetitors: 'Einzigartigkeit gegenüber Wettbewerbern',
  },
  voices: {
    positive: 'Positive',
    upset: 'Upset',
    powerful: 'Powerful',
    joking: 'Joking',
    quiet: 'Quiet',
    urgent: 'Urgent',
    soft: 'Soft',
    polite: 'Polite',
    encouraging: 'Ermutigend',
    formally: 'Formally',
    general: 'Allgemein',
    professional: 'Professionell',
    funny: 'Lustig',
    dramatic: 'Dramatisch',
    witty: 'Witzig',
    sarcastic: 'Sarkastisch',
    sad: 'Traurig',
    spirituel: 'Spirituell',
    intellectual: 'Intellektuell',
  },
  leads: {
    activecampaign: 'ActiveCampaign',
    getresponse: 'GetResponse',
    googlespreadsheets: 'Google SpreadSheets',
    klicktipp: 'KlickTipp',
    mailchimp: 'Mailchimp',
    quentn: 'Quentn',
  },
  wpPlugin: {
    installWPPlugin: 'Installieren Sie das FunKITools-Plugin auf Ihrer WordPress-Website und fügen Sie diesen Schlüssel in den Plugin-Einstellungen hinzu. Erstellen Sie Beiträge und synchronisieren Sie sie mit Ihrem Blog auf einer WordPress-Website.',
    howToConnectFunkyPlugin: 'Wie man das FunKITools WP Plugin verbindet',
    howToConnectWPPlugin: 'So verbinden Sie das WP Plugin',
    howToinstallPlugin: 'So installieren Sie das Plugin',
    connectingWPPlugin: 'Verbinden des WP-Plugins',
    connectingWPPluginTitle: 'Das Wordpress Plugin verbinden',
    youCanSynchronizeThePost: 'You can synchronize the post with an external site where the WP plugin is installed and configured.',
    loginToTheWPAdminArea: 'Melden Sie sich im WP-Admin-Bereich Ihrer Website an',
    wpAdminAreaIsUsuallyLocated: 'Der WP-Admin-Bereich befindet sich normalerweise unter https://deinedomain.com/wp-admin/. Wenn Sie sich unter dieser Adresse nicht anmelden können, überprüfen Sie mit Ihrem Systemadministrator die richtige Adresse und die Zugangsdaten.',
    goToAddNewPLugin: 'Gehen Sie zu "Neues Plugin hinzufügen" und finden Sie das FunKITools-Plugin',
    inTheLeftMenuFindThePlugins: 'Finden Sie im linken Menü den Abschnitt Plugins und klicken Sie auf "Neues Plugin hinzufügen". Geben Sie auf der sich öffnenden Seite oben rechts im Suchfeld den Wert "FunKITools" ein.',
    installTheFunkitoolsPlugin: 'Installieren Sie das FunKITools-Plugin',
    youWillSeeTheRequiredPlugin: 'Sie werden das benötigte Plugin in den Suchergebnissen sehen. Klicken Sie auf die Schaltfläche "Installieren" und folgen Sie den Anweisungen.',
    activateTheFunkitoolsPlugin: 'Aktivieren Sie das FunKITools-Plugin',
    afterTheInstallationIsComplete: 'Nach Abschluss der Installation aktivieren Sie das Plugin, indem Sie auf die entsprechende Schaltfläche neben dem Plugin klicken.',
    pasteYourAPIKey: 'Fügen Sie Ihren API-Schlüssel in die FunKITools-Plugin-Einstellungen ein',
    afterTheInstallationIsCompleteYourPluginIsReady: 'Nach Abschluss der Installation ist das Plugin zum Einsatz bereit.',
    whereCanFindTheKey: 'Wo finde ich den API-Schlüssel?',
    goToBlogSettings: 'Gehen Sie zu den Blog-Einstellungen',
    selectTheBlogYouNeed: 'Wählen Sie den gewünschten Blog aus und gehen Sie zu den Blog-Einstellungen.',
    findTheWordpressPlugin: 'Finden Sie den WordPress-Plugin-Schlüsselbereich',
    findTheWordpressPluginDescription: 'Finden Sie den WordPress-Plugin-Schlüsselbereich, der Ihren persönlichen API-Schlüssel zur Integration mit dem FunKITools WP-Plugin enthält.',
    copyTheWordpressKey: 'Kopieren Sie den WordPress-API-Schlüssel in den Blog-Einstellungen',
    onceThePluginIsInstalled: 'Sobald das Plugin installiert und aktiviert ist, gehen Sie zurück zu Ihren Blog-Einstellungen und kopieren Sie den Blog-API-Schlüssel.',
    pasteTheKeyIntoSettings: 'Fügen Sie den API-Schlüssel in die FunKITools-Plugin-Einstellungen ein',
    goBackToTheAdminArea: 'Gehen Sie zurück zum Admin-Bereich Ihrer WP-Webseite und öffnen Sie die FunKITools-Plugin-Einstellungen. Fügen Sie im Feld API-Schlüssel den kopierten Schlüssel ein und klicken Sie auf die Schaltfläche Speichern.',
    ifTheConnectionSuccess: 'Wenn die Verbindung erfolgreich ist, sehen Sie eine entsprechende Nachricht.',
    firstDownloadThePlugin: 'Laden Sie zuerst das FunKITools-Plugin auf der <a href="https://funkitools.ai/wp.html" target="_blank" class="text-primary">Plugin-Download-Seite</a> herunter.',
    pluginDownloadPage: 'Plugin Downloadseite runterladen',
    downloadThePlugin: 'Laden Sie das FunKITools-Plugin herunter',
    goToAddNewPlugin: 'Gehen Sie zu "Neues Plugin hinzufügen" und laden Sie das Plugin hoch',
    goToAddNewPluginDescription: '1. Finden Sie im linken Menü den Abschnitt „Plugins“ und klicken Sie auf „Neues Plugin hinzufügen“. <br> 2. Klicken Sie auf der sich öffnenden Seite oben links auf „Plugin hochladen“. <br> 3. Laden Sie das .zip-Archiv hoch, dass Sie im ersten Schritt heruntergeladen haben.',
    installThePlugin: 'Installieren Sie das FunKITools-Plugin',
    installThePluginDescription: 'Starten Sie die Installation, indem Sie auf die Schaltfläche „Jetzt installieren“ klicken.',
    activateThePlugin: 'Aktivieren Sie das FunKITools-Plugin',
    activateThePluginDescription: 'Nach Abschluss der Installation aktivieren Sie das Plugin, indem Sie auf die entsprechende Schaltfläche neben dem Plugin klicken.',
    pasteYourAPIKeyDescription: 'Um das Plugin zu konfigurieren, geben Sie den Blog-API-Schlüssel ein, den Sie in den Blogeinstellungen finden. Falls erforderlich, geben Sie den Autor, die Kategorien und die Tags für die veröffentlichten Beiträge standardmäßig an.',
  },
  upgradePlan: {
    wordpressPlugin: 'WordPress Plugin',
    keywordTool: 'Keyword Tool',
    ownArticles: 'Eigene Artikel',
    aiArticles: 'KI-Artikel',
    blogHosting: 'Blog Hosting',
    seoOptimizing: 'SEO Optimierung',
    newsletterTools: 'Newsletter Tool',
    customBanner: 'Custom Banner',
    removeBranding: 'FunKIBlog Wasserzeichen entfernen',
    blogTemplates: 'Blog Templates',
    webinars: 'Webinars',
    freePrice: '0€',
    proPrice: '249€ / jährlich',
    cloudPrice: '1990€ / jährlich',
    freeKeywordTool: '10 Anfragen einmalig',
    freeOwnArticles: '5 Artikel mtl.',
    freeAiArticles: '3 Artikel einmalig',
    freeBlogHosting: 'Nur Subdomain',
    freeSeoOptimizing: 'Unbegrenzt für die ersten 14 Tage',
    proKeywordTool: '300 Anfragen mtl.',
    proAiArticles: '60 Artikel mtl.',
    proBlogHosting: '1 Blog / eigene Domain',
    proSeoOptimizing: '30 Artikel',
    yourPlan: 'Dein Tarif',
    moreBlog: '1 weiterer Blog',
    moreBlogPrice: '9€ / mtl.',
    saleWithin: 'Angebot für 72 Stunden',
    keywordToolUsed: 'Verwendetes Keyword-Tool',
    ownArticlesUsed: 'Eigene Artikel verwendet',
    aiArticlesUsed: 'Verwendete KI-Artikel',
    seoOptimizingUsed: 'SEO-Optimierung',
    keywordsLeftByTime: 'Bis zum <span class="text-black q-mx-sm">{date}</span> sind noch <span class="text-black q-mx-sm">{used} Keyword-Suchanfragen</span> übrig von <span class="text-black q-ml-sm">{limit}</span>',
    keywordsLeft: '<span class="text-black q-mr-sm">{used} Keyword-Suchanfragen</span> übrig von <span class="text-black q-ml-sm">{limit}</span>',
    keywordsLeftByTimeLimitReached: 'Bis zum <span class="text-black q-mx-sm">{date}</span> sind noch <span class="text-red-3 q-mx-sm">{used} Keyword-Suchanfragen</span> übrig von <span class="text-black q-ml-sm">{limit}</span>',
    keywordsLeftLimitReached: '<span class="text-red-3 q-mr-sm">{used} Keyword-Suchanfragen</span> übrig von <span class="text-black q-ml-sm">{limit}</span>',
    wordpressPluginTooltip: 'Ein Plugin, mit dem du deine Inhalte nahtlos auf WordPress integrieren und verwalten kannst.',
    keywordToolTooltip: 'Ein Werkzeug zur effektiven Recherche und Analyse von Schlüsselwörtern für bessere SEO-Leistungen.',
    ownArticlesTooltip: 'Möglichkeit, eigene Artikel zu erstellen und zu verwalten, um einzigartige und individuelle Inhalte zu erschaffen.',
    aiArticlesTooltip: 'Automatisierte Generierung von Artikeln durch Künstliche Intelligenz, um schnell Inhalte zu erstellen.',
    blogHostingTooltip: 'Zuverlässiges Hosting für deinen Blog mit hoher Verfügbarkeit und Sicherheit.',
    seoOptimizingTooltip: 'Werkzeuge zur Optimierung deiner Inhalte für Suchmaschinen, um bessere Rankings zu erzielen.',
    newsletterToolsTooltip: 'Funktionen zur Erstellung und Verwaltung von Newslettern für eine effektive Kommunikation mit deinen Lesern.',
    customBannerTooltip: 'Individuelle Gestaltung und Einbindung von Bannern auf deiner Website zur Werbung oder Informationsverbreitung.',
    removeBrandingTooltip: 'Möglichkeit, das FunKIBlog Branding zu entfernen, um deine eigene Marke zu stärken.',
    blogTemplatesTooltip: 'Vorlagen für Blogs, um das Design und Layout deiner Website schnell und einfach anzupassen.',
    moreBlogTooltip: 'Option zur Erstellung und Verwaltung eines zusätzlichen Blogs unter demselben Account.',
  },
  reply: {
    toStartUsingService: 'Füge deine Brand hinzu, um diesen Dienst zu nutzen.',
    addFirstBrand: 'Erste Brand hinzufügen',
    addYourBrandDescription: 'Füge deine Brand hinzu, indem du den Namen, die Website-Adresse und die Beschreibung angibst. Füge Keywords hinzu, die deine Brand perfekt beschreiben. Wähle soziale Netzwerke aus, in denen du nach Erwähnungen deiner Brand suchen möchtest. Erstelle anschließend ganz einfach Antworten auf Beiträge, in denen deine Brand in sozialen Netzwerken erwähnt wird, mit nur einem Klick!',
    addBrand: 'Marke hinzufügen',
    editBrand: 'Marke bearbeiten',
    next: 'Weiter',
    finish: 'Finish',
    brandName: 'Name der Marke',
    brand: 'Marke',
    socials: 'Socials',
    keywords: 'Keywords',
    congratulations: 'Glückwunsch!',
    youAddedBrand: 'Sie haben Ihre Marke erfolgreich hinzugefügt!',
    selectSocialProfile: 'Wählen Sie das/die soziale(n) Profil(e), von dem/denen Sie Beiträge sehen möchten.',
    aiSuggestedKeywords: 'AI Vorgeschlagene Keywords',
    addPositiveKeywords: 'Positive Keywords hinzufügen',
    addNegativeKeywords: 'Negative Keywords hinzufügen',
    pleaseSelectNetwork: 'Bitte wählen Sie mindestens 1 soziale Profil',
    thisKeywordAdded: 'Dieses Keyword ist bereits hinzugefügt worden',
    myBrands: 'Meine Marken',
    addNewBrand: 'Neue Marke hinzufügen',
    deleteBrand: 'Marke löschen',
    goToMentions: 'Zu den Erwähnungen',
    beforeStartSearch: 'Bevor Sie mit der Suche beginnen, müssen Sie Keywords zur Marke hinzufügen.',
    emptyReplies: 'Sie haben noch keine Antworten erstellt',
    emptyReplied: 'Sie haben noch nicht auf eine einzige Erwähnung geantwortet',
    addVoice: 'Stimme hinzufügen',
    allSocialNetworks: 'Alle sozialen Medien',
    socialNetworks: 'Soziale Medien',
    return: 'Rückgabe',
    restrictCountry: 'Suche auf das ausgewählte Land beschränken',
    restrictCountryDescription: 'Wenn diese Option aktiviert ist, kann sie die Genauigkeit erhöhen, aber die Anzahl der erhaltenen Ergebnisse verringern.',
    restrictLanguage: 'Suche auf die ausgewählte Sprache beschränken',
    restrictLanguageDescription: 'Wenn diese Option aktiviert ist, werden nur Seiten in der ausgewählten Sprache durchsucht.',
    searchExactMatches: 'Exakte Übereinstimmungen suchen',
    searchExactMatchesDesc: 'Wenn diese Option aktiviert ist, wird die Suche nach exakten Übereinstimmungen der Keywords durchgeführt. Dadurch erhältst Du weniger, aber relevantere Ergebnisse. In manchen Fällen wird jedoch nichts gefunden. Deshalb solltest Du die Keywords sorgfältiger auswählen, um das gewünschte Ergebnis zu erzielen.',
    markedAsReplied: 'Erwähnungen als beantwortet markiert',
    markedAsSkipped: 'Erwähnung als übersprungen markiert',
    wasReturned: 'Erwähnung wurde zurückgegeben',
    markedAsUnreplied: 'Erwähnung als unbeantwortet markiert',
  },
  teams: {
    statuses: {
      active: 'Aktiv',
      disabled: 'Deaktiviert',
      pending: 'Ausstehend',
      rejected: 'Abgelehnt',
    },
    resendInvite: 'Einladung erneut senden',
    editMemberAccess: 'Mitgliederzugang bearbeiten',
    deleteMember: 'Mitglied löschen',
    disableMember: 'Mitglied deaktivieren',
    activateMember: ' Mitglied aktivieren',
    userDisabled: 'User successfully disabled',
    userActivated: 'User successfully activated',
    resend: 'Einladung gesendet',
    resendSuccess: 'Einladung wurde erfolgreich gesendet',
    teams: 'Teams',
    hereYouWillSeeTheTeams: 'Hier sehen Sie die Teams, zu denen Sie eingeladen wurden und zu denen Sie Zugang haben.',
    toOwnTeam: 'Zum eigenen Team',
    newInvitations: 'Neue Einladungen',
    youAreInvited: 'Du bist zu {team}s Team eingeladen',
    acceptOrDecline: 'Nimm die Einladung an oder lehne sie ab',
    teamName: '{team}\'s team',
    goToTeam: 'Zum Team gehen',
    leaveTeam: 'Ein Team verlassen',
    youDontHaveAccess: 'You don\'t have access',
    changeTeam: 'Change team',
    youAreNotMember: 'Sie sind kein Mitglied eines Teams.',
    youHaveNoTeams: 'You have no teams',
    team: 'Team',
    goToTeams: 'Zu Teams gehen',
  },
  hint: {
    ds24: `Den API-Key für DS24 erstellst du in deinem DS24 Account unter 'Einstellungen' > 'Kontozugriff' > 'API-Schlüssel'.<br>
      1. Klicke auf 'Neuer API-Schlüssel' und erstelle einen API-Schlüssel mit 'API-Rechte' > 'Vollzugriff'.<br>
      2. Kopiere diesen API-Schlüssel und füge ihn hier ein.<br>
      3. Klicke anschließend auf 'Speichern'.`,
  },
  placeholder: {
    findIcon: 'Icon finden',
    graphic: 'Grafisch (Gezeichnet)',
    photo: 'Realistisch (Foto)',
    searchContact: 'Kontakte durchsuchen',
  },
  routeTitles: {
    'my-book': 'Meine PDF',
    'my-profile': 'Mein Profil',
  },
};
